var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import errorStateImage from "./assets/icon-pivot.png";
var WEB_COMMON_ASSETS_MAP = {
  WEB_COMMON_ERROR_STATE_IMAGE: errorStateImage
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(WEB_COMMON_ASSETS_MAP);
};

// src/components/assessment-exit-modal/assessment-exit-modal.component.jsx
import React3, { useEffect } from "react";
import PropTypes2 from "prop-types";
import { Transition } from "react-transition-group";
import { Box as Box2, Flex as Flex3, genesisStyled } from "@leagueplatform/genesis-commons";
import { Modal } from "@leagueplatform/ui-kit";
import { getContentUrl } from "@leagueplatform/league-content-api";
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";

// src/components/cta-media-object/cta-media-object.component.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  BodyOne,
  HeadingOne,
  HeadingTwo,
  Flex,
  Box,
  Image,
  PrimaryButton,
  QuietButton
} from "@leagueplatform/genesis-commons";
import { Link as RouterLink } from "@leagueplatform/routing";
var CTAMediaObject = ({
  title,
  description,
  ctaLink,
  ctaText,
  secondaryLink,
  secondaryText,
  image,
  ctaHandler,
  secondaryHandler,
  svg,
  ctaAnalytics,
  secondaryAnalytics,
  eyebrow,
  isMobile
}) => {
  const showSecondaryLink = secondaryText && (secondaryLink || secondaryHandler);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Flex,
    {
      flexDirection: { _: "column", tablet: "initial" },
      padding: isMobile ? "0 16px" : "initial",
      marginTop: { _: "-100px", tablet: "0" }
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        flex: isMobile ? "none" : "0 0 277px",
        display: { _: "flex", tablet: "initial" },
        justifyContent: { _: "center", tablet: "initial" }
      },
      svg || /* @__PURE__ */ React.createElement(
        Image,
        {
          src: image,
          role: "presentation",
          height: isMobile ? "180px" : "280px"
        }
      )
    ),
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        flexDirection: "column",
        justifyContent: "center",
        marginLeft: { _: "0", tablet: "two" },
        textAlign: { _: "center", tablet: "initial" },
        width: "100%"
      },
      eyebrow && eyebrow,
      isMobile ? /* @__PURE__ */ React.createElement(HeadingTwo, { marginBottom: "one", marginTop: "50px" }, title) : /* @__PURE__ */ React.createElement(HeadingOne, { marginBottom: "one" }, title),
      /* @__PURE__ */ React.createElement(BodyOne, null, description)
    )
  ), /* @__PURE__ */ React.createElement(
    Flex,
    {
      marginTop: "four",
      justifyContent: "center",
      width: isMobile ? "100%" : "initial",
      padding: isMobile ? "0 16px" : "initial"
    },
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        alignItems: "center",
        width: isMobile ? "100%" : "initial",
        flexDirection: isMobile ? "column-reverse" : "row"
      },
      showSecondaryLink && /* @__PURE__ */ React.createElement(
        Box,
        {
          marginRight: { _: "none", tablet: "two" },
          width: { _: "100%", tablet: "auto" }
        },
        /* @__PURE__ */ React.createElement(
          QuietButton,
          {
            as: secondaryLink && RouterLink,
            to: secondaryLink,
            width: { _: "100%", tablet: "auto" },
            textDecoration: "none",
            onClick: (e) => {
              if (secondaryHandler) {
                e.preventDefault();
                secondaryHandler();
              }
              secondaryAnalytics();
            }
          },
          secondaryText
        )
      ),
      /* @__PURE__ */ React.createElement(
        PrimaryButton,
        {
          as: ctaLink && RouterLink,
          to: ctaLink,
          textDecoration: "none",
          width: isMobile ? "100%" : "initial",
          marginLeft: {
            _: "none",
            tablet: !showSecondaryLink ? "80px" : "none"
          },
          onClick: (e) => {
            if (ctaHandler) {
              e.preventDefault();
              ctaHandler();
            }
            ctaAnalytics();
          }
        },
        ctaText
      )
    )
  ));
};
CTAMediaObject.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaLink: PropTypes.string,
  secondaryLink: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  image: PropTypes.string,
  ctaHandler: PropTypes.func,
  secondaryHandler: PropTypes.func,
  svg: PropTypes.element,
  ctaAnalytics: PropTypes.func,
  secondaryAnalytics: PropTypes.func,
  eyebrow: PropTypes.string,
  isMobile: PropTypes.bool
};
CTAMediaObject.defaultProps = {
  secondaryLink: null,
  secondaryText: "",
  secondaryHandler: null,
  ctaHandler: null,
  ctaLink: null,
  image: "",
  eyebrow: null,
  svg: null,
  ctaAnalytics: () => {
  },
  secondaryAnalytics: () => {
  },
  isMobile: false
};

// src/components/eyebrow-earn-points/eyebrow-earn-points.component.tsx
import React2 from "react";
import { Icon, ICONS } from "@leagueplatform/ui-kit";
import { Overline, Flex as Flex2 } from "@leagueplatform/genesis-commons";
import { useIntl } from "@leagueplatform/locales";
var EyebrowEarnPoints = ({
  completionPoints
}) => {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React2.createElement(Flex2, { display: "inline-flex", marginBottom: "half", alignItems: "center" }, /* @__PURE__ */ React2.createElement(Icon, { icon: ICONS.STAR_FILLED, size: 16, "aria-hidden": true }), /* @__PURE__ */ React2.createElement(Overline, { as: "p", marginLeft: "half" }, formatMessage(
    { id: "EARN_NUMBER_POINTS_FULL" },
    { points: completionPoints }
  )));
};

// src/components/assessment-exit-modal/assessment-exit-modal.component.jsx
var Fade = genesisStyled.div`
  transition: opacity 400ms ease-in-out;
  opacity: ${({ state }) => state === "entered" ? 1 : 0};
`;
var AssessmentExitModal = ({
  setShowExit,
  exitScreen,
  ctaHandler,
  ctaAnalytics,
  secondaryAnalytics,
  completionPoints,
  sendPageAnalytics
}) => {
  useEffect(() => {
    if (sendPageAnalytics) {
      sendPageAnalytics();
    }
  }, [sendPageAnalytics]);
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));
  return /* @__PURE__ */ React3.createElement(Modal.Wrapper, { onClose: () => setShowExit(false) }, /* @__PURE__ */ React3.createElement(
    Flex3,
    {
      width: "100%",
      height: "100%",
      position: "fixed",
      backgroundColor: "surface.background.primary",
      zIndex: "sticky",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      "aria-live": "assertive"
    },
    /* @__PURE__ */ React3.createElement(Box2, { as: "main", maxWidth: "790px", padding: "twoAndHalf" }, /* @__PURE__ */ React3.createElement(Transition, { timeout: 250, in: true, appear: true, unmountOnExit: true }, (state) => /* @__PURE__ */ React3.createElement(Fade, { state }, /* @__PURE__ */ React3.createElement(
      CTAMediaObject,
      {
        eyebrow: completionPoints > 0 && /* @__PURE__ */ React3.createElement(EyebrowEarnPoints, { completionPoints }),
        title: exitScreen.title,
        description: exitScreen.description,
        ctaHandler,
        secondaryHandler: () => {
          secondaryAnalytics();
          setShowExit(false);
        },
        ctaText: exitScreen.buttonOk,
        secondaryText: exitScreen.buttonNo,
        ctaAnalytics,
        image: exitScreen.image || getContentUrl(exitScreen.imageId),
        isMobile
      }
    ))))
  ));
};
AssessmentExitModal.propTypes = {
  setShowExit: PropTypes2.func.isRequired,
  exitScreen: PropTypes2.shape({
    title: PropTypes2.string.isRequired,
    description: PropTypes2.string.isRequired,
    buttonOk: PropTypes2.string.isRequired,
    buttonNo: PropTypes2.string.isRequired,
    imageId: PropTypes2.string.isRequired,
    image: PropTypes2.string
  }).isRequired,
  ctaHandler: PropTypes2.func,
  ctaAnalytics: PropTypes2.func,
  sendPageAnalytics: PropTypes2.func,
  secondaryAnalytics: PropTypes2.func,
  completionPoints: PropTypes2.number
};
AssessmentExitModal.defaultProps = {
  ctaHandler: null,
  ctaAnalytics: () => void 0,
  secondaryAnalytics: () => void 0,
  sendPageAnalytics: null,
  completionPoints: 0
};

// src/components/dimension-of-health-modal/dimension-of-health-modal.component.tsx
import React4 from "react";
import {
  Box as Box3,
  Flex as Flex4,
  Overline as Overline2,
  HeadingOne as HeadingOne2,
  BodyOne as BodyOne2,
  SubtitleOne,
  genesisStyled as genesisStyled2,
  QuietButton as CloseButton,
  VisuallyHidden,
  Image as Image2
} from "@leagueplatform/genesis-commons";
import { Modal as Modal2, Icon as Icon2, ICONS as ICONS2, useModalA11yProps } from "@leagueplatform/ui-kit";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { openInTab } from "@leagueplatform/web-common";
import { getContentUrl as getContentUrl2 } from "@leagueplatform/league-content-api";
import IconHealthArticle from "./assets/health-article-icon.svg";
import {
  sendAnalyticsEvent,
  usePageViewAnalytics
} from "@leagueplatform/analytics";
var DIMENSION_HEALTH_MODAL_MAX_WIDTH = "574px";
var DIMENSION_HEALTH_MODAL_LABEL = "dimension-of-health-modal";
var getDimensionOfHealthScreenName = (type) => `dimensions of health ${type.toLowerCase()}`;
var InteractiveBox = genesisStyled2(Box3)`
  cursor: pointer;
`;
var DimensionOfHealthModal = ({
  title,
  description,
  imageId,
  icon,
  placeholderImage,
  url,
  onClose,
  analyticsScreenName,
  // Used only for analytics
  analyticsProductArea
}) => {
  const modalAriaProps = useModalA11yProps();
  usePageViewAnalytics(
    {
      product_area: analyticsProductArea,
      screen_name: getDimensionOfHealthScreenName(title),
      has_health_profile: true
    },
    [title]
  );
  const { formatMessage } = useIntl2();
  const healthNeedsImageSrc = imageId ? getContentUrl2(imageId) : placeholderImage;
  const imageSrc = icon || healthNeedsImageSrc;
  return /* @__PURE__ */ React4.createElement(Modal2.Wrapper, { onClose, options: {} }, /* @__PURE__ */ React4.createElement(
    Box3,
    __spreadProps(__spreadValues({
      padding: "four",
      borderRadius: "medium",
      position: "relative",
      overflowY: "scroll",
      backgroundColor: "surface.background.primary",
      maxWidth: DIMENSION_HEALTH_MODAL_MAX_WIDTH
    }, modalAriaProps), {
      "aria-labelledby": DIMENSION_HEALTH_MODAL_LABEL
    }),
    /* @__PURE__ */ React4.createElement(
      CloseButton,
      {
        onClick: onClose,
        paddingX: "half",
        paddingY: "half",
        position: "absolute",
        top: "one",
        right: "oneAndHalf"
      },
      /* @__PURE__ */ React4.createElement(VisuallyHidden, null, formatMessage({ id: "CLOSE" })),
      /* @__PURE__ */ React4.createElement(Icon2, { icon: ICONS2.CLOSE, size: 20 })
    ),
    imageSrc && /* @__PURE__ */ React4.createElement(
      Flex4,
      {
        justifyContent: "center",
        flexDirection: "column",
        height: 277,
        width: 277,
        margin: "auto"
      },
      /* @__PURE__ */ React4.createElement(Image2, { "data-testid": "dimension-image", src: imageSrc, alt: "" })
    ),
    /* @__PURE__ */ React4.createElement(
      Overline2,
      {
        as: "h1",
        color: "onSurface.text.subdued",
        marginY: "half",
        id: DIMENSION_HEALTH_MODAL_LABEL
      },
      formatMessage({ id: "DIMENSION_OF_HEALTH" })
    ),
    /* @__PURE__ */ React4.createElement(HeadingOne2, { marginBottom: "one", as: "h2" }, title),
    /* @__PURE__ */ React4.createElement(BodyOne2, { marginBottom: "twoAndHalf", color: "onSurface.text.subdued" }, description),
    url && /* @__PURE__ */ React4.createElement(
      Flex4,
      {
        padding: "oneAndHalf",
        borderColor: "interactive.border.disabled",
        borderStyle: "solid",
        borderWidth: "thin",
        borderRadius: "medium"
      },
      /* @__PURE__ */ React4.createElement(Flex4, { justifyContent: "center", width: 100, height: 72 }, /* @__PURE__ */ React4.createElement(Image2, { src: IconHealthArticle, alt: "" })),
      /* @__PURE__ */ React4.createElement(Box3, { marginLeft: "oneAndHalf", width: "100%" }, /* @__PURE__ */ React4.createElement(BodyOne2, { color: "onSurface.text.subdued", marginBottom: "half" }, formatMessage({ id: "READING_MORE_ABOUT_DIMENSIONS" })), /* @__PURE__ */ React4.createElement(
        InteractiveBox,
        {
          onClick: () => {
            sendAnalyticsEvent({
              category: analyticsScreenName,
              action: "Read Dimension of Health Article",
              label: title
            });
            openInTab(url);
          }
        },
        /* @__PURE__ */ React4.createElement(SubtitleOne, { color: "onSurface.text.primary" }, formatMessage({ id: "READ_OUR_ARTICLE" }))
      ))
    )
  ));
};

// src/components/document-card/document-card.component.tsx
import * as React5 from "react";
import {
  BodyOne as BodyOne3,
  Box as Box4,
  Caption,
  genesisStyled as genesisStyled3,
  css,
  Flex as Flex5,
  CoverImage,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
import documentIcon from "./assets/documentIcon.svg";
var StyledLink = genesisStyled3(Box4)(
  () => css({
    display: "inline-block",
    paddingX: "threeQuarters",
    paddingY: "one",
    transition: "0.2s all",
    textDecoration: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "interactive.background.hovered"
    }
  })
);
var WrappedText = genesisStyled3(BodyOne3)`
  overflow-wrap: anywhere;
`;
var DocumentCard = ({
  document: document2,
  icon = documentIcon
}) => {
  const { formatMessage, formatDate } = useIntl3();
  const { fileName, lastUpdatedAt, downloadUrl, uploadedBy } = document2;
  return /* @__PURE__ */ React5.createElement(
    Box4,
    {
      as: "li",
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderStyle: "solid",
      borderWidth: "thin"
    },
    /* @__PURE__ */ React5.createElement(StyledLink, { as: "a", href: downloadUrl, rel: "noreferrer", target: "_blank" }, /* @__PURE__ */ React5.createElement(Flex5, { alignItems: "center" }, /* @__PURE__ */ React5.createElement(
      CoverImage,
      {
        src: icon,
        size: "oneAndHalf",
        minWidth: "oneAndHalf",
        alt: "",
        marginRight: "one"
      }
    ), /* @__PURE__ */ React5.createElement(VisuallyHidden2, null, formatMessage({ id: "VIEW_DOCUMENT" })), /* @__PURE__ */ React5.createElement(Flex5, { flexDirection: "column" }, /* @__PURE__ */ React5.createElement(WrappedText, { as: "span", marginBottom: "quarter" }, fileName), /* @__PURE__ */ React5.createElement(Caption, { as: "span" }, formatMessage(
      { id: "UPLOADED_DOCUMENT" },
      {
        date: formatDate(lastUpdatedAt, SHORT_DATE_FORMAT),
        user: uploadedBy
        // TODO: This uploaded by may get removed
      }
    )))))
  );
};

// src/components/full-page-error/full-page-error.component.tsx
import React8 from "react";
import { Link, useHistory } from "@leagueplatform/routing";
import { Flex as Flex6 } from "@leagueplatform/genesis-commons";

// src/components/error-state/error-state.component.tsx
import React6, { useEffect as useEffect2, useRef } from "react";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import {
  Button,
  HeadingText,
  ImageMessage,
  ParagraphText,
  StackLayout,
  StackItem
} from "@leagueplatform/genesis-core";
var defaultTryAgainHandler = () => window.location.reload();
var ErrorContent = ({
  headingId = "THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM",
  buttonText,
  bodyString,
  headingString,
  bodyId,
  buttonId = "TRY_AGAIN",
  hideButton = false,
  hideImage,
  onButtonClick = defaultTryAgainHandler,
  labelledbyId,
  describedbyId,
  buttonPriority = "primary",
  emphasisText
}) => {
  const { formatMessage } = useIntl4();
  const buttonRef = useRef(null);
  useEffect2(() => {
    var _a;
    (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.focus();
  });
  return /* @__PURE__ */ React6.createElement(
    StackLayout,
    {
      css: { marginTop: !hideImage ? "$three" : "none", textAlign: "center" },
      horizontalAlignment: "center",
      spacing: "$twoAndHalf"
    },
    /* @__PURE__ */ React6.createElement(StackItem, null, /* @__PURE__ */ React6.createElement(StackLayout, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React6.createElement(HeadingText, { level: "2", size: "lg", id: labelledbyId }, headingString || formatMessage({ id: headingId })), (bodyId || bodyString) && /* @__PURE__ */ React6.createElement(ParagraphText, { id: describedbyId }, bodyString || formatMessage({ id: bodyId }))), emphasisText && /* @__PURE__ */ React6.createElement(ParagraphText, null, /* @__PURE__ */ React6.createElement("strong", null, emphasisText))),
    !hideButton && /* @__PURE__ */ React6.createElement(StackItem, null, /* @__PURE__ */ React6.createElement(
      Button,
      {
        onClick: onButtonClick,
        ref: buttonRef,
        priority: buttonPriority
      },
      buttonText || formatMessage({ id: buttonId })
    ))
  );
};
var ErrorState = (_a) => {
  var _b = _a, {
    hideImage = false,
    imageSrc
  } = _b, props = __objRest(_b, [
    "hideImage",
    "imageSrc"
  ]);
  if (hideImage)
    return /* @__PURE__ */ React6.createElement(ErrorContent, __spreadValues({}, props));
  const errorStateImage2 = handleStaticAsset(
    "WEB_COMMON_ERROR_STATE_IMAGE" /* WEB_COMMON_ERROR_STATE_IMAGE */
  );
  return /* @__PURE__ */ React6.createElement(ImageMessage, { image: imageSrc || errorStateImage2 }, /* @__PURE__ */ React6.createElement(ErrorContent, __spreadValues({}, props)));
};

// src/components/back-button-arrow/back-button-arrow.view.jsx
import React7 from "react";
import PropTypes3 from "prop-types";
import {
  QuietButton as QuietButton2,
  Image as Image3,
  genesisStyled as genesisStyled4,
  css as css2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import BackIcon from "./assets/back.svg";
var BackButton = genesisStyled4(QuietButton2)(
  css2({
    "&:hover, &:active, &:focus": {
      background: "transparent !important",
      transform: "translateX(-3px)"
    }
  })
);
var BackButtonArrow = (_a) => {
  var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
  const { formatMessage } = useIntl5();
  return /* @__PURE__ */ React7.createElement(
    BackButton,
    __spreadValues({
      onClick,
      backgroundColor: "transparent",
      height: "two",
      minWidth: "two",
      paddingX: "none",
      paddingY: "none"
    }, props),
    /* @__PURE__ */ React7.createElement(
      Image3,
      {
        display: "block",
        src: BackIcon,
        width: 24,
        height: 24,
        alt: formatMessage({ id: "GO_BACK" })
      }
    )
  );
};
BackButtonArrow.propTypes = {
  onClick: PropTypes3.func
};
BackButtonArrow.defaultProps = {
  onClick: () => {
  }
};

// src/components/full-page-error/full-page-error.component.tsx
var FullPageError = ({ route }) => {
  const history = useHistory();
  return /* @__PURE__ */ React8.createElement(
    Flex6,
    {
      flexDirection: { _: "column", phone: "row" },
      height: "100%",
      justifyContent: { _: "flex-start", phone: "center" },
      padding: { _: "oneAndHalf", phone: "twoAndHalf" }
    },
    /* @__PURE__ */ React8.createElement(
      BackButtonArrow,
      {
        as: route && Link,
        justifyContent: "initial",
        marginRight: "quarter",
        marginY: "half",
        onClick: route ? null : history.goBack,
        to: route,
        size: "three"
      }
    ),
    /* @__PURE__ */ React8.createElement(
      Flex6,
      {
        alignItems: "center",
        justifyContent: "center",
        paddingX: { _: "none", phone: "five" }
      },
      /* @__PURE__ */ React8.createElement(ErrorState, null)
    )
  );
};

// src/components/page-header-background/page-header-background.tsx
import React9 from "react";
import { Flex as Flex7, genesisStyled as genesisStyled5, css as css3 } from "@leagueplatform/genesis-commons";
import { useUiConfig } from "@leagueplatform/ui-config";
var DEFAULT_STYLES = {
  height: "140px",
  width: "20024px",
  backgroundColor: "surface.background.tertiary"
};
var StyledPageHeaderBackground = genesisStyled5(Flex7)(
  ({
    pageHeader,
    height = DEFAULT_STYLES.height,
    pageHeaderBackgroundHeight = DEFAULT_STYLES.height
  }) => {
    var _a;
    return css3({
      height,
      backgroundColor: "transparent",
      "&:before": css3({
        backgroundColor: `${(_a = pageHeader == null ? void 0 : pageHeader.backgroundColor) != null ? _a : DEFAULT_STYLES.backgroundColor}`,
        content: '""',
        zIndex: "-1",
        position: "absolute",
        top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.width})`,
        left: `calc(50% - (${DEFAULT_STYLES.width} / 2))`,
        width: `${DEFAULT_STYLES.width}`,
        height: `${DEFAULT_STYLES.width}`,
        borderRadius: `${(pageHeader == null ? void 0 : pageHeader.shape) === "line" ? 0 : DEFAULT_STYLES.width}`
      })
    });
  }
);
var PageHeaderBackground = (_a) => {
  var _b = _a, {
    height,
    pageHeaderBackgroundHeight
  } = _b, rest = __objRest(_b, [
    "height",
    "pageHeaderBackgroundHeight"
  ]);
  var _a2;
  const [uiConfig] = useUiConfig();
  const pageHeaderConfig = (_a2 = uiConfig.components) == null ? void 0 : _a2.pageHeader;
  return /* @__PURE__ */ React9.createElement(
    StyledPageHeaderBackground,
    __spreadValues({
      height,
      pageHeaderBackgroundHeight,
      pageHeader: pageHeaderConfig
    }, rest)
  );
};

// src/components/loading-indicator/loading-indicator.component.tsx
import React10 from "react";
import styled from "styled-components";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { useUiConfig as useUiConfig2 } from "@leagueplatform/ui-config";
import { Spinner, genesisStyled as genesisStyled6, Box as Box5 } from "@leagueplatform/genesis-commons";
var LoaderContainer = genesisStyled6(Box5)`
  min-height: 300px;
  position: relative;
  ${(props) => !props.inline && `
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  `};
`;
var IndicatorContainer = styled.div`
  width: 200px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
var LoadingText = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
`;
var LoadingIndicator = ({ inline }) => {
  var _a;
  const { formatMessage } = useIntl6();
  const [uiConfig] = useUiConfig2();
  const loadingConfig = (_a = uiConfig == null ? void 0 : uiConfig.components) == null ? void 0 : _a.loading;
  const loadingComponent = (loadingConfig == null ? void 0 : loadingConfig.element) || /* @__PURE__ */ React10.createElement(Spinner, { isLoading: true, renderLoadingText: false });
  const loadingMessage = (loadingConfig == null ? void 0 : loadingConfig.text) || formatMessage({ id: "LOADING" });
  return /* @__PURE__ */ React10.createElement(LoaderContainer, { inline }, /* @__PURE__ */ React10.createElement(IndicatorContainer, null, loadingComponent, (loadingConfig == null ? void 0 : loadingConfig.text) !== false && /* @__PURE__ */ React10.createElement(LoadingText, null, loadingMessage)));
};

// src/components/main-page-container/main-page-container.tsx
import { Flex as Flex8 } from "@leagueplatform/genesis-commons";
import React11 from "react";
var CONTENT_MAX_WIDTH = "1272px";
var MainPageContainer = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React11.createElement(
    Flex8,
    __spreadValues({
      maxWidth: CONTENT_MAX_WIDTH,
      marginX: "auto",
      padding: { _: "oneAndHalf", phone: "two" },
      flexDirection: "column"
    }, props),
    children
  );
};

// src/components/swoop-header/swoop-header.view.jsx
import React12 from "react";
import PropTypes4 from "prop-types";
import { Box as Box6, QuietButton as QuietButton3, Image as Image4 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import BackIcon2 from "./assets/back.svg";
var SwoopHeader = (_a) => {
  var _b = _a, { onBackClick, children } = _b, props = __objRest(_b, ["onBackClick", "children"]);
  const { formatMessage } = useIntl7();
  return /* @__PURE__ */ React12.createElement(
    PageHeaderBackground,
    __spreadValues({
      paddingX: "twoAndHalf",
      paddingTop: "twoAndHalf",
      marginX: "auto"
    }, props),
    onBackClick !== null && /* @__PURE__ */ React12.createElement(Box6, { marginRight: "one" }, /* @__PURE__ */ React12.createElement(
      QuietButton3,
      {
        marginTop: 2,
        width: "two",
        height: "two",
        paddingX: 0,
        paddingY: 0,
        borderRadius: "circle",
        onClick: onBackClick
      },
      /* @__PURE__ */ React12.createElement(
        Image4,
        {
          src: BackIcon2,
          position: "relative",
          top: "quarter",
          left: "quarter",
          size: "oneAndHalf",
          alt: formatMessage({ id: "GO_BACK" })
        }
      )
    )),
    children
  );
};
SwoopHeader.propTypes = {
  children: PropTypes4.node.isRequired,
  onBackClick: PropTypes4.func
};
SwoopHeader.defaultProps = {
  onBackClick: null
};

// src/components/user-profile-modal/profile-modal.component.tsx
import React13 from "react";
import {
  Box as Box7,
  QuietButton as QuietButton4,
  genesisStyled as genesisStyled7,
  css as css4,
  VisuallyHidden as VisuallyHidden3,
  Image as Image5
} from "@leagueplatform/genesis-commons";
import { Modal as Modal3 } from "@leagueplatform/ui-kit";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import CLOSE_ICON from "./assets/close.svg";
var StyledModalContainer = genesisStyled7(Modal3.Container)(
  css4({
    position: "relative",
    maxWidth: 620,
    borderRadius: "medium",
    overflow: "auto"
  })
);
var StyledModalBody = genesisStyled7(Modal3.Body)(
  css4({
    padding: "twoAndHalf"
  })
);
var ProfileModal = ({
  onClose,
  children,
  "aria-labelledby": ariaLabelledBy
}) => {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React13.createElement(Modal3.Wrapper, { options: {}, onClose }, /* @__PURE__ */ React13.createElement(StyledModalContainer, { "aria-labelledby": ariaLabelledBy }, /* @__PURE__ */ React13.createElement(Box7, { position: "absolute", right: "0" }, /* @__PURE__ */ React13.createElement(QuietButton4, { margin: "one", padding: "half", onClick: onClose }, /* @__PURE__ */ React13.createElement(VisuallyHidden3, null, formatMessage({ id: "CLOSE" })), /* @__PURE__ */ React13.createElement(
    Image5,
    {
      src: CLOSE_ICON,
      role: "presentation",
      size: "threeQuarters",
      "aria-hidden": "true"
    }
  ))), /* @__PURE__ */ React13.createElement(StyledModalBody, null, children)));
};

// src/components/form-fields/field-wrapper.component.jsx
import React14 from "react";
import PropTypes5 from "prop-types";
import { FormattedMessage } from "react-intl";
import { FormattedHTMLMessage } from "@leagueplatform/locales";
import {
  breakpoints,
  DottedTooltipModal,
  TooltipHeader,
  Responsive
} from "@leagueplatform/ui-kit";
import {
  Label,
  LabelText,
  Box as Box8,
  ErrorMessage,
  Flex as Flex9
} from "@leagueplatform/genesis-commons";
var FieldWrapper = ({
  label,
  tooltip,
  tooltipValues,
  children,
  htmlFor,
  error,
  labelId,
  groupedField
}) => /* @__PURE__ */ React14.createElement(
  Label,
  {
    htmlFor,
    id: labelId,
    as: groupedField ? "fieldset" : "label"
  },
  /* @__PURE__ */ React14.createElement(
    LabelText,
    {
      as: groupedField ? "legend" : void 0,
      justifyContent: "space-between",
      alignItems: "flex-end",
      width: 1,
      marginBottom: "quarter"
    },
    /* @__PURE__ */ React14.createElement(Flex9, null, /* @__PURE__ */ React14.createElement(Box8, { flexGrow: 1 }, label), tooltip && /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(Responsive, { breakpoint: breakpoints.lapAndAbove }, /* @__PURE__ */ React14.createElement(
      TooltipHeader,
      {
        tooltipLink: /* @__PURE__ */ React14.createElement(Box8, { fontWeight: "regular" }, /* @__PURE__ */ React14.createElement(FormattedMessage, { id: "WHY_DO_YOU_ASK" })),
        tooltipText: /* @__PURE__ */ React14.createElement(
          Box8,
          {
            minWidth: 350,
            fontSize: "body2",
            fontWeight: "regular",
            color: "onSurface.text.primary"
          },
          /* @__PURE__ */ React14.createElement(FormattedHTMLMessage, { id: tooltip, values: tooltipValues })
        ),
        verticalPosition: "bottom: 3rem;",
        pointerPosition: 50,
        inline: true
      }
    )), /* @__PURE__ */ React14.createElement(Responsive, { breakpoint: breakpoints.belowLap }, /* @__PURE__ */ React14.createElement(
      DottedTooltipModal,
      {
        label: /* @__PURE__ */ React14.createElement(FormattedMessage, { id: "WHY_DO_YOU_ASK" }),
        content: /* @__PURE__ */ React14.createElement(FormattedHTMLMessage, { id: tooltip, values: tooltipValues }),
        marginTop: "minusThreeQuarters",
        inline: true
      }
    ))))
  ),
  /* @__PURE__ */ React14.createElement(Box8, null, children),
  error && /* @__PURE__ */ React14.createElement(ErrorMessage, null, error)
);
FieldWrapper.propTypes = {
  label: PropTypes5.oneOfType([PropTypes5.string, PropTypes5.node]).isRequired,
  children: PropTypes5.node.isRequired,
  htmlFor: PropTypes5.string.isRequired,
  tooltip: PropTypes5.string,
  // eslint-disable-next-line react/forbid-prop-types
  tooltipValues: PropTypes5.objectOf(PropTypes5.any),
  labelId: PropTypes5.string,
  error: PropTypes5.oneOfType([
    PropTypes5.bool,
    PropTypes5.string,
    PropTypes5.shape({
      code: PropTypes5.string,
      description: PropTypes5.string
    })
  ]),
  groupedField: PropTypes5.bool
};
FieldWrapper.defaultProps = {
  tooltip: null,
  tooltipValues: {},
  error: null,
  labelId: void 0,
  groupedField: false
};

// src/components/form-fields/input-field.component.jsx
import React20 from "react";
import PropTypes7 from "prop-types";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { Field } from "formik";

// src/components/form-fields/select-field.component.jsx
import React15 from "react";
import { Select } from "@leagueplatform/genesis-core";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/components/form-fields/field-shape.jsx
import PropTypes6 from "prop-types";
var fieldProps = {
  field: PropTypes6.shape({
    name: PropTypes6.string.isRequired,
    value: PropTypes6.any
  }),
  form: PropTypes6.shape({
    setFieldValue: PropTypes6.func,
    setFieldError: PropTypes6.func,
    setFieldTouched: PropTypes6.func
  }),
  options: PropTypes6.arrayOf(
    PropTypes6.shape({
      label: PropTypes6.string.isRequired,
      value: PropTypes6.any.isRequired
    })
  ),
  placeholder: PropTypes6.string,
  required: PropTypes6.bool,
  disabled: PropTypes6.bool,
  readOnly: PropTypes6.bool,
  hasError: PropTypes6.bool
};

// src/components/form-fields/select-field.component.jsx
var SelectField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), _e = _b, {
    form: { handleBlur, setFieldValue },
    inputId,
    disabled,
    readOnly,
    placeholder
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "inputId",
    "disabled",
    "readOnly",
    "placeholder"
  ]);
  const { formatMessage } = useIntl9();
  return /* @__PURE__ */ React15.createElement(
    Select,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      name,
      id: inputId,
      placeholder: placeholder != null ? placeholder : formatMessage({ id: "SELECT_ONE" }),
      disabled: Boolean(disabled != null ? disabled : readOnly),
      onBlur: ({ value }) => {
        handleBlur({ target: { value, name } });
      },
      onChange: (evt) => {
        const value = evt ? evt.currentTarget.value : null;
        setFieldValue(name, value);
      },
      "data-testid": `select_field_${name}`
    })
  );
};
SelectField.propTypes = fieldProps;

// src/components/form-fields/text-field.component.jsx
import React16 from "react";
import { TextInput } from "@leagueplatform/genesis-commons";
var TextField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), {
    disabled = false,
    readOnly = false,
    hasError = false,
    required,
    inputId,
    placeholder = null
  } = _b;
  return /* @__PURE__ */ React16.createElement(
    TextInput,
    __spreadProps(__spreadValues({}, field), {
      required,
      name,
      id: inputId,
      disabled: Boolean(disabled != null ? disabled : readOnly),
      error: hasError,
      placeholder
    })
  );
};
TextField.propTypes = fieldProps;

// src/components/form-fields/date-field.component.jsx
import React17 from "react";
import { DateInput } from "@leagueplatform/ui-kit";
var DateField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), _e = _b, {
    form: { setFieldValue, setFieldTouched, setFieldError },
    disabled,
    readOnly
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "disabled",
    "readOnly"
  ]);
  return /* @__PURE__ */ React17.createElement(
    DateInput,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      name,
      setFieldError,
      onChange: (e, { error }) => {
        setFieldValue(name, error || e.currentTarget.value, !error);
        if (error)
          setFieldError(name, error);
      },
      onBlur: (_, { error }) => {
        setFieldTouched(name, true, !error);
        if (error) {
          setFieldError(name, error);
        }
      },
      disabled: Boolean(disabled != null ? disabled : readOnly)
    })
  );
};
DateField.propTypes = fieldProps;

// src/components/form-fields/multiselect-field.component.jsx
import React18 from "react";
import { MultiSelect } from "@leagueplatform/ui-kit";
var MultiSelectField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name, value } = _d, field = __objRest(_d, ["name", "value"]), _e = _b, {
    form: { setFieldValue },
    disabled,
    readOnly,
    options,
    required
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "disabled",
    "readOnly",
    "options",
    "required"
  ]);
  var _a2;
  const optionValues = (_a2 = value == null ? void 0 : value.map((option) => {
    var _a3;
    return (_a3 = option == null ? void 0 : option.value) != null ? _a3 : option;
  })) != null ? _a2 : [];
  const selectedValues = optionValues.map(
    (optionValue) => {
      var _a3;
      return (_a3 = options.find((option) => option.value === optionValue)) != null ? _a3 : {
        label: optionValue,
        value: optionValue
      };
    }
  );
  return /* @__PURE__ */ React18.createElement(
    MultiSelect,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      required,
      name,
      options,
      disabled: Boolean(disabled != null ? disabled : readOnly),
      onChange: (selectedOptions, action) => {
        if (!action)
          return;
        const selectedOptionsArray = selectedOptions || [];
        setFieldValue(
          name,
          selectedOptionsArray.map((opt) => opt.value)
        );
      },
      value: selectedValues,
      "data-testid": `multi_select_field_${name}`,
      canCreate: true
    })
  );
};
MultiSelectField.propTypes = fieldProps;

// src/components/form-fields/radio-field.component.jsx
import React19 from "react";
import {
  Radio,
  Label as Label2,
  ChoiceText,
  Flex as Flex10
} from "@leagueplatform/genesis-commons";
var RadioField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name, value } = _d, field = __objRest(_d, ["name", "value"]), {
    form: { setFieldValue },
    inputId,
    required,
    disabled,
    readOnly,
    options,
    hasError
  } = _b;
  const isDisabled = Boolean(disabled != null ? disabled : readOnly);
  const isBooleanField = options.some(
    (option) => typeof option.value === "boolean"
  );
  return /* @__PURE__ */ React19.createElement(
    Flex10,
    {
      alignItems: "center",
      role: "radiogroup",
      "aria-labelledby": `${inputId}_label`,
      id: inputId
    },
    options == null ? void 0 : options.map((option, idx) => /* @__PURE__ */ React19.createElement(
      Label2,
      {
        key: `${name}_${option.value}`,
        marginLeft: idx > 0 ? "one" : "none",
        display: "flex",
        paddingTop: "one"
      },
      /* @__PURE__ */ React19.createElement(
        Radio,
        __spreadProps(__spreadValues({}, field), {
          name: inputId,
          value: option.value,
          required,
          disabled: isDisabled,
          checked: option.value === value,
          error: hasError,
          onChange: ({ target }) => {
            const newValue = isBooleanField ? target.value === "true" : target.value;
            setFieldValue(name, newValue);
          }
        })
      ),
      /* @__PURE__ */ React19.createElement(ChoiceText, { marginLeft: "threeQuarters" }, option.label)
    ))
  );
};
RadioField.propTypes = fieldProps;

// src/components/form-fields/input-field.constants.js
var TEXT = "text";
var SELECT = "select";
var MULTISELECT = "multiselect";
var RADIO = "radio";
var CHECKBOX = "checkbox";
var DATE = "date";
var HIDDEN = "hidden";

// src/components/form-fields/input-field.component.jsx
var isGroupedField = (fieldType) => [DATE, RADIO].includes(fieldType);
var InputField = (_a) => {
  var _b = _a, {
    inputType,
    name,
    label,
    value,
    required,
    tooltip,
    tooltipValues,
    getError,
    formId
  } = _b, otherProps = __objRest(_b, [
    "inputType",
    "name",
    "label",
    "value",
    "required",
    "tooltip",
    "tooltipValues",
    "getError",
    "formId"
  ]);
  const { formatMessage } = useIntl10();
  if (!inputType)
    return null;
  if (inputType === HIDDEN)
    return /* @__PURE__ */ React20.createElement(Field, { name }, ({ field }) => /* @__PURE__ */ React20.createElement("input", __spreadProps(__spreadValues({}, field), { type: "hidden" })));
  const error = getError ? getError(name) : otherProps.error;
  const labelId = formId ? `${formId}_${name}_label` : `${name}_label`;
  const inputId = formId ? `${formId}_${name}` : name;
  return /* @__PURE__ */ React20.createElement(
    FieldWrapper,
    __spreadProps(__spreadValues({}, otherProps), {
      label: formatMessage({ id: label }),
      isRequired: required,
      tooltip,
      tooltipValues,
      error,
      htmlFor: inputId,
      labelId,
      groupedField: isGroupedField(inputType)
    }),
    /* @__PURE__ */ React20.createElement(Field, { name }, ({ field, form }) => {
      const fieldProps2 = __spreadProps(__spreadValues({}, otherProps), {
        field,
        form,
        inputId,
        hasError: Boolean(error)
      });
      switch (inputType) {
        case TEXT:
          return /* @__PURE__ */ React20.createElement(TextField, __spreadValues({}, fieldProps2));
        case SELECT:
          return /* @__PURE__ */ React20.createElement(SelectField, __spreadValues({}, fieldProps2));
        case MULTISELECT:
          return /* @__PURE__ */ React20.createElement(MultiSelectField, __spreadValues({}, fieldProps2));
        case DATE:
          return /* @__PURE__ */ React20.createElement(DateField, __spreadValues({}, fieldProps2));
        case RADIO:
          return /* @__PURE__ */ React20.createElement(RadioField, __spreadValues({}, fieldProps2));
        default:
          return null;
      }
    })
  );
};
InputField.propTypes = {
  inputType: PropTypes7.string,
  name: PropTypes7.string,
  label: PropTypes7.string,
  formId: PropTypes7.string,
  placeholder: PropTypes7.string,
  required: PropTypes7.bool,
  tooltip: PropTypes7.string,
  tooltipValues: PropTypes7.any,
  // eslint-disable-line
  getError: PropTypes7.func,
  disabled: PropTypes7.bool,
  value: PropTypes7.any
  // eslint-disable-line
};
InputField.defaultProps = {
  inputType: void 0,
  name: void 0,
  label: void 0,
  formId: void 0,
  placeholder: void 0,
  required: false,
  tooltip: null,
  tooltipValues: void 0,
  disabled: false,
  getError: void 0,
  value: null
};
InputField.displayName = "InputField";

// src/components/form-fields/field-grid.component.jsx
import React21 from "react";
import { Flex as Flex11 } from "@leagueplatform/genesis-commons";
var FieldGrid = (props) => /* @__PURE__ */ React21.createElement(Flex11, __spreadValues({ flexWrap: "wrap" }, props));

// src/components/form-fields/field-section.component.js
import styled2 from "styled-components";
import { vars, Box as Box9 } from "@leagueplatform/ui-kit";
var FieldSection = styled2(Box9)`
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      ${vars.colour.white},
      ${vars.colour.navyLightest} 20%,
      ${vars.colour.navyLightest} 80%,
      ${vars.colour.white}
    );
  }
`;

// src/components/opens-in-a-new-tab-message/opens-in-a-new-tab-message.component.tsx
import React22 from "react";
import { VisuallyHidden as VisuallyHidden4 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
var OpensInANewTabMessage = () => {
  const { formatMessage } = useIntl11();
  return /* @__PURE__ */ React22.createElement(VisuallyHidden4, null, formatMessage({ id: "OPENS_IN_A_NEW_TAB" }));
};

// src/components/with-hidden-description/with-hidden-description.component.tsx
import * as React23 from "react";
import { VisuallyHidden as VisuallyHidden5 } from "@leagueplatform/genesis-commons";
var WithHiddenDescription = ({
  children,
  description
}) => {
  if (!children)
    return null;
  return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", { "aria-hidden": "true" }, children), /* @__PURE__ */ React23.createElement(VisuallyHidden5, null, description));
};

// src/components/very-quiet-button/very-quiet-button.component.jsx
import * as React24 from "react";
import { bool } from "prop-types";
import { genesisStyled as genesisStyled8, QuietButton as QuietButton5 } from "@leagueplatform/genesis-commons";
var getTextColor = ({ theme }) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.onSurface) == null ? void 0 : _b.text) == null ? void 0 : _c.primary;
};
var getBackgroundColor = ({ theme, darkenBackground }) => {
  var _a, _b, _c, _d, _e, _f;
  return darkenBackground ? (_c = (_b = (_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.surface) == null ? void 0 : _b.background) == null ? void 0 : _c.secondary : (_f = (_e = (_d = theme == null ? void 0 : theme.colors) == null ? void 0 : _d.surface) == null ? void 0 : _e.background) == null ? void 0 : _f.primary;
};
var getTextDecoration = ({ hideUnderline }) => hideUnderline ? "inherit" : "underline";
var StyledQuietButton = genesisStyled8(QuietButton5)`
  &:hover, &:focus {
    text-decoration: ${getTextDecoration};
    background-color: ${getBackgroundColor};
    color: ${getTextColor};
  }
`;
var VeryQuietButton = (_a) => {
  var _b = _a, {
    darkenBackground = false,
    hideUnderline = false
  } = _b, props = __objRest(_b, [
    "darkenBackground",
    "hideUnderline"
  ]);
  return /* @__PURE__ */ React24.createElement(
    StyledQuietButton,
    __spreadValues({
      darkenBackground,
      hideUnderline
    }, props)
  );
};
VeryQuietButton.propTypes = {
  hideUnderline: bool,
  darkenBackground: bool
};
VeryQuietButton.defaultProps = {
  hideUnderline: false,
  darkenBackground: false
};

// src/components/status-badge/status-badge.component.tsx
import React25 from "react";
import {
  Flex as Flex12,
  Box as Box10,
  SubtitleTwo,
  Caption as Caption2,
  VisuallyHidden as VisuallyHidden6
} from "@leagueplatform/genesis-commons";
var STATUS_OPTIONS = /* @__PURE__ */ ((STATUS_OPTIONS2) => {
  STATUS_OPTIONS2["SUCCESS"] = "SUCCESS";
  STATUS_OPTIONS2["HIGHLIGHT"] = "HIGHLIGHT";
  STATUS_OPTIONS2["WARNING"] = "WARNING";
  STATUS_OPTIONS2["CRITICAL"] = "CRITICAL";
  STATUS_OPTIONS2["DISABLED"] = "DISABLED";
  return STATUS_OPTIONS2;
})(STATUS_OPTIONS || {});
var colorScheme = {
  SUCCESS: {
    backgroundColor: "success.background.subdued",
    iconColor: "success.icon"
  },
  HIGHLIGHT: {
    backgroundColor: "highlight.background.subdued",
    iconColor: "highlight.icon"
  },
  WARNING: {
    backgroundColor: "warning.background.subdued",
    iconColor: "warning.icon"
  },
  CRITICAL: {
    backgroundColor: "critical.background.subdued",
    iconColor: "critical.icon"
  },
  DISABLED: {
    backgroundColor: "surface.card.disabled",
    iconColor: "interactive.icon.disabled"
  }
};
var getStatusColors = (status) => colorScheme[status];
var StatusBadge = ({
  status,
  label,
  displayIcon,
  smallText,
  accessibleDescription
}) => {
  const { backgroundColor, iconColor } = getStatusColors(status);
  return /* @__PURE__ */ React25.createElement(
    Flex12,
    {
      width: "fit-content",
      alignItems: "center",
      paddingX: "half",
      paddingY: "quarter",
      backgroundColor,
      borderRadius: "pill"
    },
    displayIcon && /* @__PURE__ */ React25.createElement(
      Box10,
      {
        height: 10,
        width: 10,
        minWidth: 10,
        backgroundColor: iconColor,
        borderRadius: "circle",
        marginRight: "quarter",
        role: "presentation"
      }
    ),
    smallText ? /* @__PURE__ */ React25.createElement(Caption2, null, /* @__PURE__ */ React25.createElement(VisuallyHidden6, null, accessibleDescription, "\xA0"), label) : /* @__PURE__ */ React25.createElement(SubtitleTwo, { as: "p" }, /* @__PURE__ */ React25.createElement(VisuallyHidden6, null, accessibleDescription, "\xA0"), label)
  );
};

// src/components/pill-tabs/pill-tabs.component.tsx
import * as React26 from "react";
import {
  Tabs as T,
  Button as Button2
} from "@leagueplatform/genesis-core";
function PillTabList(_a) {
  var _b = _a, { children, css: css21 } = _b, props = __objRest(_b, ["children", "css"]);
  return /* @__PURE__ */ React26.createElement(
    T.TabList,
    __spreadValues({
      css: __spreadValues({
        backgroundColor: "$surfaceBackgroundPrimary",
        borderColor: "$highlightBackgroundSubdued",
        borderRadius: "$pill",
        borderWidth: "$thin",
        boxShadow: "$card",
        padding: "$half $quarter $half $half"
      }, css21),
      tabDistribution: "hugContents"
    }, props),
    children
  );
}
function PillTab(_a) {
  var _b = _a, {
    value,
    children,
    css: css21
  } = _b, props = __objRest(_b, [
    "value",
    "children",
    "css"
  ]);
  const [isTabSelected, setTabSelectedState] = React26.useState(false);
  const tabRef = React26.useCallback((node) => {
    if (node !== null) {
      setTabSelectedState(node.getAttribute("data-state") === "active");
    }
  }, []);
  return /* @__PURE__ */ React26.createElement(
    Button2,
    __spreadValues({
      as: T.Tab,
      value,
      css: __spreadValues({
        borderRadius: "$pill",
        fontSize: "$subtitleTwo",
        marginRight: "$quarter",
        padding: "$quarter $threeQuarters",
        '&[class*="GDS"]:focus': {
          outlineOffset: "$borderWidths$outerFocus"
        },
        "&[data-state=active]": {
          color: "$primaryTextDefault",
          borderBottomColor: "transparent"
        },
        "&[data-state=inactive]": {
          "&:hover": {
            backgroundColor: "$decorativeBrandPrimaryPastel",
            color: "$onSurfaceTextPrimary"
          }
        }
      }, css21),
      size: "small",
      ref: tabRef,
      quiet: !isTabSelected,
      priority: isTabSelected ? "primary" : "secondary"
    }, props),
    children
  );
}
function PillTabs(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React26.createElement(
    T.Root,
    __spreadValues({
      activationMode: "manual",
      css: {
        "& .GDS-tab-list-wrapper": {
          overflow: "unset"
        }
      }
    }, props),
    children
  );
}

// src/components/accordion/accordion-root.component.tsx
import React27, { useMemo } from "react";
import * as RadixAccordionPrimitive from "@radix-ui/react-accordion";
import { Box as Box11 } from "@leagueplatform/genesis-core";
var accordionRootStyles = {
  "> * + *": {
    marginTop: "$two"
  },
  "> * > * + *": {
    marginTop: "$one"
  },
  ".cc-accordion-trigger": {
    background: "none",
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    padding: "$quarter $none",
    width: "100%",
    "&:hover, &:focus": {
      background: "none",
      color: "inherit"
    },
    "> span": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    ".cc-accordion-trigger-icon": {
      transition: "transform 200ms",
      marginRight: "$minusHalf"
    },
    "&[aria-expanded=true] .cc-accordion-trigger-icon": {
      transform: "rotate(180deg)"
    }
  }
};
var Root2 = React27.forwardRef((_a, forwardedRef) => {
  var _b = _a, { className, css: css21 } = _b, props = __objRest(_b, ["className", "css"]);
  const composedClassName = useMemo(
    () => ["cc-accordion", "cc-accordion-root", className].join(" "),
    [className]
  );
  const composedCss = useMemo(
    () => __spreadValues(__spreadValues({}, accordionRootStyles), css21),
    [css21]
  );
  return /* @__PURE__ */ React27.createElement(
    Box11,
    __spreadProps(__spreadValues({}, props), {
      as: RadixAccordionPrimitive.Root,
      className: composedClassName,
      css: composedCss,
      ref: forwardedRef
    })
  );
});
Root2.displayName = "Accordion.Root";

// src/components/accordion/accordion-item.component.tsx
import React28, { useMemo as useMemo2 } from "react";
import * as RadixAccordionPrimitive2 from "@radix-ui/react-accordion";
import { Box as Box12 } from "@leagueplatform/genesis-core";
var AccordionItemContext = React28.createContext({
  itemId: "",
  triggerId: "",
  contentId: ""
});
var Item2 = React28.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { className, value } = _b, props = __objRest(_b, ["className", "value"]);
    const context = useMemo2(
      () => ({
        itemId: value,
        triggerId: `${value}-trigger`,
        contentId: `${value}-content`
      }),
      [value]
    );
    const composedClassName = useMemo2(
      () => ["cc-accordion-item", className].join(" "),
      [className]
    );
    return /* @__PURE__ */ React28.createElement(AccordionItemContext.Provider, { value: context }, /* @__PURE__ */ React28.createElement(
      Box12,
      __spreadProps(__spreadValues({}, props), {
        as: RadixAccordionPrimitive2.Item,
        className: composedClassName,
        ref: forwardedRef,
        value
      })
    ));
  }
);
Item2.displayName = "Accordion.Item";

// src/components/accordion/accordion-header.component.tsx
import React29, { useMemo as useMemo3 } from "react";
import * as RadixAccordionPrimitive3 from "@radix-ui/react-accordion";
import { HeadingText as HeadingText2 } from "@leagueplatform/genesis-core";
var Header2 = React29.forwardRef((_a, forwardedRef) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const composedClassName = useMemo3(
    () => ["cc-accordion-header", className].join(" "),
    [className]
  );
  return /* @__PURE__ */ React29.createElement(RadixAccordionPrimitive3.Header, { asChild: true }, /* @__PURE__ */ React29.createElement(
    HeadingText2,
    __spreadProps(__spreadValues({}, props), {
      className: composedClassName,
      ref: forwardedRef
    })
  ));
});
Header2.displayName = "Accordion.Header";

// src/components/accordion/accordion-trigger.component.tsx
import React30, { useMemo as useMemo4 } from "react";
import * as RadixAccordionPrimitive4 from "@radix-ui/react-accordion";
import {
  Box as Box13,
  Button as Button3,
  Icon as Icon3
} from "@leagueplatform/genesis-core";
var Trigger2 = React30.forwardRef((_a, forwardedRef) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  const { triggerId, contentId } = React30.useContext(AccordionItemContext);
  const composedClassName = useMemo4(
    () => ["cc-accordion-trigger", className].join(" "),
    [className]
  );
  return /* @__PURE__ */ React30.createElement(
    Button3,
    __spreadProps(__spreadValues({}, props), {
      "aria-controls": contentId,
      as: RadixAccordionPrimitive4.Trigger,
      className: composedClassName,
      id: triggerId,
      ref: forwardedRef
    }),
    /* @__PURE__ */ React30.createElement(Box13, { as: "span" }, children),
    /* @__PURE__ */ React30.createElement(Icon3, { icon: "interfaceChevronDown", className: "cc-accordion-trigger-icon" })
  );
});
Trigger2.displayName = "Accordion.Trigger";

// src/components/accordion/accordion-content.component.tsx
import React31, { useMemo as useMemo5 } from "react";
import * as RadixAccordionPrimitive5 from "@radix-ui/react-accordion";
import { Box as Box14 } from "@leagueplatform/genesis-core";
var Content2 = React31.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    const { triggerId, contentId } = React31.useContext(AccordionItemContext);
    const composedClassName = useMemo5(
      () => ["cc-accordion-content", className].join(" "),
      [className]
    );
    return /* @__PURE__ */ React31.createElement(
      Box14,
      __spreadProps(__spreadValues({}, props), {
        "aria-labelledby": triggerId,
        as: RadixAccordionPrimitive5.Content,
        className: composedClassName,
        id: contentId,
        ref: forwardedRef
      })
    );
  }
);
Content2.displayName = "Accordion.Content";

// src/components/accordion/accordion.component.tsx
var Accordion = {
  Root: Root2,
  Item: Item2,
  Header: Header2,
  Trigger: Trigger2,
  Content: Content2
};

// src/components/carousel/carousel.component.tsx
import React36, { useRef as useRef2, useEffect as useEffect3, useState as useState2, useCallback as useCallback2 } from "react";
import {
  Flex as Flex14,
  css as css6,
  genesisStyled as genesisStyled10,
  Box as Box15,
  BodyOne as BodyOne4
} from "@leagueplatform/genesis-commons";
import {
  useSwipeGestures,
  SWIPE_ORIENTATION,
  SWIPE_DIRECTION
} from "@leagueplatform/web-common";
import { tween, easing } from "popmotion";

// src/components/carousel/carousel-cta-link.component.tsx
import React33 from "react";

// src/components/internal-or-external-link/internal-or-external-link.component.tsx
import React32, { forwardRef } from "react";
import { Link as GenesisLink } from "@leagueplatform/genesis-commons";
import { Link as RouterLink2 } from "@leagueplatform/routing";
import { isAbsoluteUrl } from "@leagueplatform/web-common";
var InternalOrExternalLink = forwardRef((_a, ref) => {
  var _b = _a, { href, children } = _b, linkProps = __objRest(_b, ["href", "children"]);
  const { isExternalUrl: isExternalUrl2 = isAbsoluteUrl(href) } = linkProps;
  const isExternalUrlOrPhoneNumber = isExternalUrl2 || href.includes("tel:");
  return /* @__PURE__ */ React32.createElement(
    GenesisLink,
    __spreadValues({
      ref,
      as: isExternalUrlOrPhoneNumber ? GenesisLink : RouterLink2,
      to: isExternalUrlOrPhoneNumber ? void 0 : href,
      href: isExternalUrlOrPhoneNumber ? href : void 0,
      target: isExternalUrl2 ? "_blank" : void 0,
      rel: isExternalUrl2 ? "noopener noreferrer" : void 0
    }, linkProps),
    children
  );
});

// src/components/carousel/carousel-cta-link.component.tsx
var CTALink = ({
  children,
  ariaLabel,
  href,
  onClick
}) => /* @__PURE__ */ React33.createElement(InternalOrExternalLink, { href, onClick, "aria-label": ariaLabel }, children);

// src/components/carousel/carousel-progress-dots.component.tsx
import React34 from "react";
import { Flex as Flex13, genesisStyled as genesisStyled9, css as css5 } from "@leagueplatform/genesis-commons";
var ProgressDot = genesisStyled9(Flex13)(
  ({ isActive }) => css5({
    height: "threeQuarters",
    width: "threeQuarters",
    cursor: "pointer",
    backgroundColor: isActive ? "interactive.action.primary" : "interactive.action.disabled"
  })
);
var ProgressDots = ({ length, currentDot }) => {
  const progressDots = new Array(length).fill(true);
  return /* @__PURE__ */ React34.createElement(
    Flex13,
    {
      position: "absolute",
      flexDirection: "row",
      justify: "center",
      align: "center",
      bottom: "0",
      width: "100%",
      justifyContent: "center"
    },
    progressDots.map((active, index) => {
      const key = `progress-dot-${index}-${active}`;
      return /* @__PURE__ */ React34.createElement(
        ProgressDot,
        {
          borderRadius: "circle",
          marginX: "threeQuarters",
          isActive: currentDot === index,
          key
        }
      );
    })
  );
};

// src/components/carousel/carousel-nav-button.component.tsx
import React35 from "react";
import { SubtleButton } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import { ICONS as ICONS3 } from "@leagueplatform/ui-kit";
var NavButton = ({ disabled, onClick, label, icon }) => /* @__PURE__ */ React35.createElement(
  SubtleButton,
  {
    borderRadius: "circle",
    width: "two",
    height: "two",
    paddingX: "none",
    paddingY: "none",
    paddingTop: "one",
    paddingBottom: "threeQuarters",
    transition: "visibility 300ms, opacity 300ms",
    disabled,
    onClick,
    "aria-label": label
  },
  icon
);
var LeftNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl12();
  return /* @__PURE__ */ React35.createElement(
    NavButton,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "SCROLL_CAROUSEL_LEFT" }),
      icon: ICONS3.LEFT_CHEVRON[0]
    }
  );
};
var RightNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl12();
  return /* @__PURE__ */ React35.createElement(
    NavButton,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "SCROLL_CAROUSEL_RIGHT" }),
      icon: ICONS3.RIGHT_CHEVRON[0]
    }
  );
};

// src/components/carousel/carousel.component.tsx
var shouldShowNavigation = ({
  offsetWidth,
  children
}) => {
  if (!children || children.length === 0)
    return false;
  return children[0].offsetWidth * children.length > offsetWidth;
};
var CarouselInnerWrapper = genesisStyled10(Flex14)(
  ({ spaceBetweenCards }) => css6({
    "& > *": {
      marginRight: spaceBetweenCards,
      "&:last-child": {
        marginRight: 0
      }
    }
  })
);
var Carousel = ({
  name,
  children,
  spaceBetweenCards = "one",
  heading,
  description,
  linkOnClick,
  linkAriaLabel,
  linkCta,
  linkUrl,
  LeftNavButtonAnalyticsFn = () => null,
  RightNavButtonAnalyticsFn = () => null,
  sideArrows = false,
  showProgressDots = false,
  onIndexChange,
  titleMarginBottom = "oneAndHalf"
}) => {
  const carouselRef = useRef2(null);
  const childrenRef = useRef2([]);
  const [rightArrowDisabled, setRightArrowDisabled] = useState2(true);
  const [leftArrowDisabled, setLeftArrowDisabled] = useState2(true);
  const [showNavButtons, setShowNavButtons] = useState2(true);
  const swipeDirection = useSwipeGestures(
    carouselRef,
    SWIPE_ORIENTATION.horizontal
  );
  const [currentProgressIndex, setCurrentProgressIndex] = useState2(0);
  const childrenLength = React36.Children.toArray(children).length;
  const [childrenInView, setChildrenInView] = useState2([]);
  const currentCarouselProperties = () => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const { scrollLeft, offsetWidth, scrollWidth } = currentCarouselRef;
      const firstChild = currentCarouselRef.children[0];
      const childrenWidth = firstChild.offsetWidth + parseInt(getComputedStyle(firstChild).marginRight, 10);
      const currentIndex = parseInt(
        (scrollLeft / childrenWidth).toString(),
        10
      );
      const amountOfChildrenInView = Math.round(offsetWidth / childrenWidth);
      const userScroll = offsetWidth + scrollLeft;
      return {
        currentCarouselRef,
        scrollLeft,
        offsetWidth,
        scrollWidth,
        userScroll,
        firstChild,
        childrenWidth,
        currentIndex,
        amountOfChildrenInView
      };
    }
    return null;
  };
  const updateChildrenInView = useCallback2(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { amountOfChildrenInView, currentIndex, userScroll, scrollWidth } = carouselProperties;
      const lastChildOffset = childrenLength > 1 && userScroll > scrollWidth ? 1 : 0;
      const currentChildIndex = currentIndex + lastChildOffset;
      if (amountOfChildrenInView === 1)
        return setChildrenInView([currentChildIndex]);
      const inView = [];
      for (let x = 0; x < amountOfChildrenInView; x += 1) {
        inView.push(currentChildIndex + x);
      }
      setChildrenInView(inView);
    }
    return null;
  }, [childrenLength]);
  const updateChildrenTabIndex = useCallback2(() => {
    childrenRef.current.forEach((elementRef, index) => {
      var _a, _b;
      const elementInView = childrenInView.find((el) => el === index);
      if (elementInView !== void 0) {
        (_a = elementRef.querySelector('*[tabindex="-1"]')) == null ? void 0 : _a.setAttribute("tabindex", "0");
      } else {
        (_b = elementRef.querySelector('*[tabindex="0"]')) == null ? void 0 : _b.setAttribute("tabindex", "-1");
      }
    });
  }, [childrenInView, childrenRef]);
  const scrollingEvent = useCallback2(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { scrollLeft, scrollWidth, userScroll } = carouselProperties;
      setLeftArrowDisabled(scrollLeft === 0);
      setRightArrowDisabled(userScroll >= scrollWidth);
    }
  }, []);
  useEffect3(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { scrollWidth, offsetWidth, currentCarouselRef } = carouselProperties;
      setRightArrowDisabled(scrollWidth <= offsetWidth);
      currentCarouselRef.addEventListener("scroll", scrollingEvent);
      setShowNavButtons(shouldShowNavigation(currentCarouselRef));
      childrenRef.current = childrenRef.current.slice(0, childrenLength);
      updateChildrenInView();
      return () => {
        currentCarouselRef.removeEventListener("scroll", scrollingEvent);
      };
    }
    return () => null;
  }, [children, childrenLength, scrollingEvent, updateChildrenInView]);
  useEffect3(() => {
    updateChildrenTabIndex();
  }, [childrenInView, updateChildrenTabIndex]);
  const onResizeCarousel = useCallback2(() => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const showNavigation = shouldShowNavigation(currentCarouselRef);
      if (showNavigation !== showNavButtons) {
        setShowNavButtons(showNavigation);
        currentCarouselRef.dispatchEvent(
          new CustomEvent("scroll", { detail: { scrollLeft: 0 } })
        );
      }
    }
  }, [showNavButtons, carouselRef]);
  useEffect3(() => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const carouselResize = new ResizeObserver(onResizeCarousel);
      carouselResize.observe(currentCarouselRef);
      return () => {
        carouselResize.disconnect();
      };
    }
    return () => null;
  }, [carouselRef, onResizeCarousel]);
  useEffect3(() => {
    if (onIndexChange) {
      if (currentProgressIndex < 0 || currentProgressIndex >= childrenLength)
        return;
      onIndexChange(currentProgressIndex);
    }
  }, [childrenLength, currentProgressIndex, onIndexChange]);
  const scrollTo = (to = 0, duration = 0) => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const from = currentCarouselRef.scrollLeft;
      const scroll = tween({
        from,
        to,
        duration,
        ease: easing.easeOut
      });
      scroll.start({
        update: (left) => {
          currentCarouselRef.scrollLeft = left;
        },
        complete: () => {
          updateChildrenInView();
        }
      });
    }
  };
  const handleNavButtonEvent = (type) => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const {
        currentIndex,
        amountOfChildrenInView,
        childrenWidth,
        scrollLeft
      } = carouselProperties;
      if (type === "RIGHT" /* right */) {
        scrollTo((currentIndex + amountOfChildrenInView) * childrenWidth, 200);
        setCurrentProgressIndex(currentIndex + 1);
      } else if (type === "LEFT" /* left */) {
        scrollTo(
          scrollLeft % childrenWidth === 0 ? (currentIndex - amountOfChildrenInView) * childrenWidth : currentIndex * childrenWidth,
          200
        );
        setCurrentProgressIndex((prevIndex) => prevIndex - 1);
      }
    }
  };
  const LeftNavButtonEvent = () => {
    handleNavButtonEvent("LEFT" /* left */);
    LeftNavButtonAnalyticsFn();
  };
  const RightNavButtonEvent = () => {
    handleNavButtonEvent("RIGHT" /* right */);
    RightNavButtonAnalyticsFn();
  };
  useEffect3(() => {
    if (swipeDirection) {
      switch (swipeDirection) {
        case SWIPE_DIRECTION.right:
          RightNavButtonEvent();
          break;
        case SWIPE_DIRECTION.left:
          LeftNavButtonEvent();
          break;
        default:
          break;
      }
    }
  }, [swipeDirection]);
  if (children === void 0) {
    console.warn(`No children found for carousel: ${name}`);
    return null;
  }
  if (!!linkUrl && linkCta === void 0 || !!linkCta && linkUrl === void 0) {
    if (linkCta === void 0) {
      console.warn(
        `Link CTA will not render. "linkUrl" prop provided, but "linkCta" prop missing for carousel: ${name}. Please provide both props.`
      );
    } else {
      console.warn(
        `Link CTA will not render. "linkCta" prop provided, but "linkUrl" prop missing for carousel: ${name}. Please provide both props.`
      );
    }
  }
  let descriptionWrapper = description;
  if (description && typeof description === "string") {
    descriptionWrapper = /* @__PURE__ */ React36.createElement(BodyOne4, { color: "onSurface.text.subdued" }, description);
  }
  return /* @__PURE__ */ React36.createElement(Flex14, { flexDirection: "column", overflow: "hidden", "data-testid": "carousel" }, /* @__PURE__ */ React36.createElement(Box15, { marginBottom: titleMarginBottom }, /* @__PURE__ */ React36.createElement(
    Flex14,
    {
      alignItems: "center",
      justifyContent: heading ? "space-between" : "flex-end"
    },
    heading,
    /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        marginLeft: "threeQuarters",
        alignItems: "center",
        flexDirection: { _: "column", phone: "row" },
        columnGap: "oneAndHalf",
        rowGap: "threeQuarters"
      },
      linkCta && linkUrl && /* @__PURE__ */ React36.createElement(
        CTALink,
        {
          onClick: linkOnClick,
          ariaLabel: linkAriaLabel,
          href: linkUrl
        },
        linkCta
      ),
      showNavButtons && !sideArrows && /* @__PURE__ */ React36.createElement(Flex14, { paddingY: "quarter", columnGap: "one", marginRight: "4px" }, /* @__PURE__ */ React36.createElement(
        LeftNavButton,
        {
          disabled: leftArrowDisabled,
          onClick: LeftNavButtonEvent
        }
      ), /* @__PURE__ */ React36.createElement(
        RightNavButton,
        {
          disabled: rightArrowDisabled,
          onClick: RightNavButtonEvent
        }
      ))
    )
  ), descriptionWrapper), /* @__PURE__ */ React36.createElement(
    Flex14,
    {
      width: "100%",
      justifyContent: "space-between",
      minWidth: "100%",
      position: "relative"
    },
    /* @__PURE__ */ React36.createElement(
      CarouselInnerWrapper,
      {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        as: "ul",
        ref: carouselRef,
        spaceBetweenCards,
        paddingBottom: showProgressDots ? "four" : "quarter",
        padding: "quarter"
      },
      React36.Children.map(children, (child, index) => /* @__PURE__ */ React36.createElement(
        "li",
        {
          ref: (element) => {
            if (element !== null) {
              childrenRef.current[index] = element;
            }
            return null;
          }
        },
        child
      ))
    ),
    sideArrows && showNavButtons && /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        position: "absolute",
        left: "one",
        top: "50%",
        zIndex: 1,
        transform: "translateY(-50%)"
      },
      /* @__PURE__ */ React36.createElement(
        LeftNavButton,
        {
          disabled: leftArrowDisabled,
          onClick: LeftNavButtonEvent
        }
      )
    ),
    sideArrows && showNavButtons && /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        position: "absolute",
        right: "one",
        top: "50%",
        zIndex: 1,
        transform: "translateY(-50%)"
      },
      /* @__PURE__ */ React36.createElement(
        RightNavButton,
        {
          disabled: rightArrowDisabled,
          onClick: RightNavButtonEvent
        }
      )
    ),
    showProgressDots && childrenLength >= 2 && /* @__PURE__ */ React36.createElement(
      ProgressDots,
      {
        currentDot: currentProgressIndex,
        length: childrenLength
      }
    )
  ));
};

// src/components/card-banner/card-banner.component.tsx
import React37 from "react";
import { isAbsoluteUrl as isAbsoluteUrl2 } from "@leagueplatform/web-common";
import {
  css as css7,
  genesisStyled as genesisStyled11,
  Flex as Flex15
} from "@leagueplatform/genesis-commons";
var StaticWrapper = genesisStyled11(Flex15)(
  ({ backgroundColor, theme, styles }) => css7(__spreadValues({
    flex: 1,
    flexDirection: "column-reverse",
    backgroundColor: backgroundColor || "surface.card.primary",
    borderStyle: "solid",
    borderColor: "onSurface.border.subdued",
    borderWidth: "thin",
    borderRadius: "large",
    overflow: "hidden",
    [`@media screen and (min-width: ${theme.breakpoints.phone})`]: {
      minHeight: "200px",
      flexDirection: "row"
    }
  }, styles))
);
var LinkableWrapper = genesisStyled11(StaticWrapper)(
  ({ backgroundColor }) => css7({
    "&::before": {
      borderRadius: "large"
    },
    "&:hover": {
      textDecoration: "none",
      backgroundColor: !backgroundColor && "interactive.background.hovered",
      borderColor: "interactive.border.hovered"
    },
    "&:active": {
      backgroundColor: !backgroundColor && "interactive.background.pressed"
    }
  })
);
var StyledChildren = genesisStyled11(Flex15)(
  css7({
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    padding: "oneAndHalf"
  })
);
var StyledImageContainer = genesisStyled11(Flex15)(
  ({ styles, theme, src }) => css7(__spreadValues({
    [`@media screen and (min-width: ${theme.breakpoints.phone})`]: {
      maxWidth: "280px",
      flexBasis: "100%",
      flexShrink: "0",
      borderLeftStyle: "solid",
      borderColor: "onSurface.border.subdued",
      borderWidth: "thin"
    },
    width: "100%",
    minHeight: "200px",
    background: `url(${src}) center no-repeat`,
    backgroundSize: "cover"
  }, styles))
);
var CardBanner = ({
  url,
  image,
  children,
  backgroundColor,
  styles,
  onClick
}) => {
  if (url) {
    const isExternalUrl2 = isAbsoluteUrl2(url);
    return /* @__PURE__ */ React37.createElement(
      LinkableWrapper,
      {
        href: url,
        onClick,
        isExternalUrl: isExternalUrl2,
        as: InternalOrExternalLink,
        backgroundColor,
        styles: styles == null ? void 0 : styles.wrapper
      },
      /* @__PURE__ */ React37.createElement(StyledChildren, null, children, isExternalUrl2 && /* @__PURE__ */ React37.createElement(OpensInANewTabMessage, null)),
      /* @__PURE__ */ React37.createElement(StyledImageContainer, { styles: styles == null ? void 0 : styles.imageContainer, src: image })
    );
  }
  return /* @__PURE__ */ React37.createElement(StaticWrapper, { backgroundColor, styles: styles == null ? void 0 : styles.wrapper }, /* @__PURE__ */ React37.createElement(StyledChildren, null, children), /* @__PURE__ */ React37.createElement(StyledImageContainer, { styles: styles == null ? void 0 : styles.imageContainer, src: image }));
};

// src/components/stack-layout/stack-layout.component.tsx
import React38 from "react";
import {
  Box as Box16,
  styled as styled3
} from "@leagueplatform/genesis-core";
var StackLayoutBox = styled3(Box16, {
  "&& > * + *": {
    marginTop: "$$space"
  }
});
var StackLayout2 = ({
  space = "$one",
  css: css21,
  children,
  as: asElement
}) => /* @__PURE__ */ React38.createElement(StackLayoutBox, { as: asElement, css: __spreadProps(__spreadValues({}, css21), { $$space: `$space${space}` }) }, children);

// src/components/app-store-icons/appstore-icons.tsx
import React39 from "react";
import { Link as Link2, Image as Image6 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import appStoreEN from "./assets/download-appstore-badge-en.svg";
import playStoreEN from "./assets/download-google-play-badge-en.svg";
import appStoreFR from "./assets/download-appstore-badge-fr.svg";
import playStoreFR from "./assets/download-google-play-badge-fr.svg";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
var LEAGUE_APP_GOOGLE_STORE_URL = "https://play.google.com/store/apps/details?id=life.league";
var LEAGUE_APP_APPLE_STORE_URL = "https://apps.apple.com/ca/app/league-health-wellness-professionals/id952832544";
var APP_ICON_SRC = {
  APPLE: {
    fr: appStoreFR,
    en: appStoreEN
  },
  GOOGLE: {
    fr: playStoreFR,
    en: playStoreEN
  }
};
function getAppIcon(type, locale) {
  const appIcon = APP_ICON_SRC[type];
  if (locale.includes("fr")) {
    return appIcon.fr;
  }
  if (locale.includes("en")) {
    return appIcon.en;
  }
  return "";
}
var AppleAppIcon = ({
  imageSize,
  href = LEAGUE_APP_APPLE_STORE_URL
}) => {
  const { formatMessage, locale } = useIntl13();
  return /* @__PURE__ */ React39.createElement(
    Link2,
    {
      href,
      onClick: () => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          screen_name: "Member Download App",
          detail: "Download Apple Store App",
          sub_detail: "Download on the App Store"
        });
      }
    },
    /* @__PURE__ */ React39.createElement(
      Image6,
      {
        alt: formatMessage({ id: "DOWNLOAD_APP_STORE" }),
        src: getAppIcon("APPLE", locale),
        height: imageSize,
        width: "auto",
        display: "block"
      }
    )
  );
};
var GoogleAppIcon = ({
  imageSize,
  href = LEAGUE_APP_GOOGLE_STORE_URL
}) => {
  const { formatMessage, locale } = useIntl13();
  return /* @__PURE__ */ React39.createElement(
    Link2,
    {
      href,
      onClick: () => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          screen_name: "Member Download App",
          detail: "Download Google Play App",
          sub_detail: "Get it on Google Play"
        });
      }
    },
    /* @__PURE__ */ React39.createElement(
      Image6,
      {
        alt: formatMessage({ id: "DOWNLOAD_PLAY_STORE" }),
        src: getAppIcon("GOOGLE", locale),
        height: imageSize,
        width: "auto",
        display: "block"
      }
    )
  );
};

// src/components/sidebar/sidebar.tsx
import React40 from "react";
import { Flex as Flex16, css as css8, genesisStyled as genesisStyled12 } from "@leagueplatform/genesis-commons";
var SIDEBAR_MIN_WIDTH = "282px";
var gapValue = { gap: "oneAndHalf" };
var addSidebarSpacing = css8(__spreadProps(__spreadValues({}, gapValue), {
  flexDirection: "column"
}));
var SidebarItemContainer = genesisStyled12(Flex16)(css8(__spreadValues({}, gapValue)));
function Sidebar({ children }) {
  return /* @__PURE__ */ React40.createElement(
    SidebarItemContainer,
    {
      flexDirection: { _: "column", phone: "row", laptop: "column" },
      justifyContent: "space-between",
      alignItems: { phone: "center", laptop: "initial" },
      minWidth: { laptop: SIDEBAR_MIN_WIDTH },
      maxWidth: { laptop: "282px" },
      width: "100%",
      padding: { _: "oneAndHalf", laptop: "none" },
      borderStyle: { _: "solid", laptop: "none" },
      borderWidth: "thin",
      borderColor: "onSurface.border.subdued",
      bottom: { _: "0", laptop: "initial" },
      left: { _: "0", laptop: "initial" },
      position: { _: "fixed", laptop: "initial" },
      backgroundColor: { _: "surface.background.primary", laptop: "initial" },
      marginY: { laptop: "oneAndHalf" },
      zIndex: "1"
    },
    children
  );
}

// src/components/sidebar/sidebar-card.tsx
import * as React41 from "react";
import { Box as Box17 } from "@leagueplatform/genesis-commons";
function SidebarCard(props) {
  return /* @__PURE__ */ React41.createElement(
    Box17,
    __spreadValues({
      borderStyle: { laptop: "solid" },
      borderWidth: "thin",
      borderColor: "interactive.border.disabled",
      borderRadius: "medium",
      backgroundColor: "surface.background.primary",
      boxShadow: { laptop: "card" },
      padding: { laptop: "oneAndHalf" }
    }, props)
  );
}

// src/components/feedback-card/feedback-card.component.tsx
import React43 from "react";
import {
  Flex as Flex18,
  HeadingFour,
  SubtitleOne as SubtitleOne2,
  Box as Box18
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import range from "lodash/range";

// src/components/feedback-card/components/feedback-input.component.tsx
import {
  genesisStyled as genesisStyled13,
  Flex as Flex17,
  css as css9,
  BodyOne as BodyOne5
} from "@leagueplatform/genesis-commons";
import * as React42 from "react";
var CIRCLE_SIZE_LARGE = "56px";
var CIRCLE_SIZE_SMALL = "34px";
var CircleLabel = genesisStyled13(Flex17)(
  ({ isSmall, theme }) => css9({
    textDecoration: "none",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    backgroundColor: "transparent",
    borderWidth: "thin",
    borderStyle: "solid",
    borderColor: "decorative.brand.primary.default",
    transition: "all 250ms ease-in-out",
    borderRadius: "circle",
    fontWeight: "bold",
    color: "decorative.brand.primary.default",
    height: isSmall ? CIRCLE_SIZE_SMALL : CIRCLE_SIZE_LARGE,
    width: isSmall ? CIRCLE_SIZE_SMALL : CIRCLE_SIZE_LARGE,
    fontSize: isSmall ? "subtitle1" : "heading2",
    "&:hover": {
      backgroundColor: "decorative.brand.primary.default",
      color: "onSurface.text.reversed"
    },
    "&:focus": {
      backgroundColor: "decorative.brand.primary.default",
      color: "onSurface.text.reversed",
      outlineWidth: "thick",
      outlineColor: "secondary.background.hovered",
      outlineStyle: "solid"
    },
    [`@media screen and (max-width: ${theme.breakpoints.tablet})`]: {
      height: CIRCLE_SIZE_SMALL,
      width: CIRCLE_SIZE_SMALL,
      fontSize: "subtitle1"
    }
  })
);
var ExpandedLabel = genesisStyled13(BodyOne5)(
  ({ isSmall, theme }) => css9({
    color: "inherit",
    whiteSpace: "nowrap",
    fontSize: isSmall ? "subtitle2" : "inherit",
    position: ["absolute", "initial"],
    top: `calc(100% - ${theme.space.half}px)`,
    left: "50%",
    transform: ["translateX(-50%)", "none"],
    [`@media screen and (max-width: ${theme.breakpoints.tablet})`]: {
      fontSize: "subtitle1"
    }
  })
);
var FeedbackInput = ({
  label,
  ariaLabel,
  value,
  expandedLabel,
  isSmall = true,
  href,
  isFirst,
  onClick
}) => {
  const EXPANDED_LABEL_ID = `feedback-expanded-label-${isFirst ? "first" : "last"}`;
  return /* @__PURE__ */ React42.createElement(
    Flex17,
    {
      display: ["inline-block", "flex"],
      alignItems: "center",
      gap: ["none", "one"],
      justifyContent: "center",
      position: "relative",
      paddingBottom: ["half", "none", "none"]
    },
    isFirst && expandedLabel && /* @__PURE__ */ React42.createElement(ExpandedLabel, { id: EXPANDED_LABEL_ID, isSmall }, expandedLabel),
    /* @__PURE__ */ React42.createElement(
      CircleLabel,
      {
        as: "a",
        href,
        isSmall,
        "data-testid": "feedback-rating-item",
        "aria-label": ariaLabel,
        "aria-describedby": expandedLabel ? EXPANDED_LABEL_ID : void 0,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => {
          if (onClick) {
            onClick(value);
          }
        }
      },
      label
    ),
    !isFirst && expandedLabel && /* @__PURE__ */ React42.createElement(ExpandedLabel, { id: EXPANDED_LABEL_ID, isSmall }, expandedLabel)
  );
};

// src/components/feedback-card/feedback-card.component.tsx
var FeedbackCard = ({
  backgroundColor = "surface.background.secondary",
  title,
  subtitle,
  min = 1,
  max = 5,
  size = "small",
  minMaxTextColor = "onSurface.text.subdued",
  onClick,
  feedbackUrl = "#"
}) => {
  const { formatMessage } = useIntl14();
  const isSmall = size === "small";
  const hasSubtitle = !!subtitle;
  return /* @__PURE__ */ React43.createElement(
    Flex18,
    {
      flexDirection: "column",
      borderRadius: "medium",
      backgroundColor,
      alignItems: "center",
      padding: "two"
    },
    /* @__PURE__ */ React43.createElement(StackLayout2, { space: "$half", css: { width: "100%", textAlign: "center" } }, /* @__PURE__ */ React43.createElement(Box18, null, /* @__PURE__ */ React43.createElement(HeadingFour, { as: "h2" }, title)), /* @__PURE__ */ React43.createElement(
      Box18,
      {
        as: "fieldset",
        flexDirection: "column",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        textAlign: "center"
      },
      hasSubtitle && /* @__PURE__ */ React43.createElement(SubtitleOne2, { as: "legend" }, subtitle),
      /* @__PURE__ */ React43.createElement(
        Flex18,
        {
          alignItems: "center",
          maxWidth: isSmall ? "450px" : "85%",
          width: 1,
          color: minMaxTextColor,
          gap: "half",
          justifyContent: "space-around",
          marginTop: "two"
        },
        range(min, max + 1).map((number, index) => {
          let expandedLabel;
          if (index === 0) {
            expandedLabel = formatMessage({
              id: "FEEDBACK_MIN_SCALE"
            });
          } else if (number === max) {
            expandedLabel = formatMessage({
              id: "FEEDBACK_MAX_SCALE"
            });
          }
          return /* @__PURE__ */ React43.createElement(
            FeedbackInput,
            {
              key: `feedback-input-item-${number}`,
              value: number,
              ariaLabel: formatMessage(
                { id: "FEEDBACK_LINK_LABEL" },
                { value: number, maximum: max }
              ),
              label: `${number}`,
              href: `${feedbackUrl}${number}`,
              onClick,
              isFirst: index === 0,
              isSmall,
              expandedLabel
            }
          );
        })
      )
    ))
  );
};

// src/components/page-not-found/page-not-found.component.tsx
import * as React45 from "react";
import {
  BodyOne as BodyOne6,
  Box as Box19,
  Flex as Flex19,
  HeadingTwo as HeadingTwo2,
  PrimaryButton as PrimaryButton2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl15 } from "@leagueplatform/locales";

// src/components/genesis-router-link/genesis-router-link.jsx
import React44 from "react";
import { Link as Link3 } from "@leagueplatform/genesis-commons";
import { Link as LinkDOM } from "@leagueplatform/routing";
var GenesisRouterLink = (props) => /* @__PURE__ */ React44.createElement(Link3, __spreadValues({ as: LinkDOM }, props));

// src/components/page-not-found/page-not-found.component.tsx
function PageNotFound({
  redirectLink = "/",
  buttonText
}) {
  const { formatMessage } = useIntl15();
  return /* @__PURE__ */ React45.createElement(
    Flex19,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "surface.background.secondary",
      textAlign: "center",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    /* @__PURE__ */ React45.createElement(
      Box19,
      {
        borderRadius: "small",
        paddingY: "two",
        paddingX: "four",
        width: "45rem",
        backgroundColor: "surface.background.primary",
        boxShadow: "card"
      },
      /* @__PURE__ */ React45.createElement(StackLayout2, { space: "$two" }, /* @__PURE__ */ React45.createElement(HeadingTwo2, null, formatMessage({ id: "PAGE_NOT_FOUND_HEADER" })), /* @__PURE__ */ React45.createElement(Box19, null, /* @__PURE__ */ React45.createElement(BodyOne6, null, formatMessage({ id: "PAGE_NOT_FOUND_CONTENT" })), /* @__PURE__ */ React45.createElement(BodyOne6, null, formatMessage({ id: "PAGE_NOT_FOUND_CONTENT_SECONDARY" }))), /* @__PURE__ */ React45.createElement(PrimaryButton2, { as: GenesisRouterLink, to: redirectLink }, buttonText != null ? buttonText : formatMessage({ id: "PAGE_NOT_FOUND_BUTTON" })))
    )
  );
}

// src/components/avatar/avatar.component.tsx
import React46 from "react";
import {
  BodyOne as BodyOne7,
  Flex as Flex20,
  genesisStyled as genesisStyled14,
  CoverImage as CoverImage2
} from "@leagueplatform/genesis-commons";
var UserInitials = genesisStyled14(BodyOne7)`
  text-transform: uppercase;
`;
var Avatar = (_a) => {
  var _b = _a, {
    imageSrc,
    userInitials,
    altText = "",
    fontSize = "body1"
  } = _b, props = __objRest(_b, [
    "imageSrc",
    "userInitials",
    "altText",
    "fontSize"
  ]);
  return /* @__PURE__ */ React46.createElement(
    Flex20,
    __spreadValues({
      overflow: "hidden",
      borderRadius: "circle",
      width: "four",
      height: "four",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "interactive.border.disabled",
      borderWidth: imageSrc ? "none" : "thin",
      borderStyle: "solid",
      backgroundColor: "surface.card.primary"
    }, props),
    imageSrc ? /* @__PURE__ */ React46.createElement(
      CoverImage2,
      {
        src: imageSrc,
        alt: altText,
        size: "100%",
        role: "presentation"
      }
    ) : userInitials && /* @__PURE__ */ React46.createElement(UserInitials, { "aria-hidden": "true", fontSize }, userInitials)
  );
};

// src/components/app-nav-bar/app-nav.component.tsx
import React50 from "react";

// src/components/app-nav-bar/app-nav.header.component.tsx
import React47 from "react";
import {
  Box as Box20,
  StackLayout as StackLayout3,
  TextAction,
  styled as styled4,
  queryHelpers as queryHelpers2,
  useMediaQuery as useMediaQuery2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
var APP_NAV_DEFAULT_HEIGHT = 8 * 7;
var SkipContentBox = styled4(Box20, {
  position: "absolute",
  zIndex: "$dropdown",
  "&:focus-within": {
    // include the focus outline when positioning
    left: "$quarter",
    top: "$quarter"
  }
});
var AppBarHeader = ({
  children,
  navHeight = APP_NAV_DEFAULT_HEIGHT,
  enableSkipToContent = true
}) => {
  const { formatMessage } = useIntl16();
  const isMobile = useMediaQuery2(queryHelpers2.down("mobileLandscape"));
  return /* @__PURE__ */ React47.createElement(
    StackLayout3,
    {
      id: "app_nav",
      as: "header",
      role: "banner",
      horizontalAlignment: "spaceBetween",
      "data-testid": "react_member_app_nav",
      orientation: "horizontal",
      verticalAlignment: "stretch",
      css: {
        color: "$onSurfaceTextSubdued",
        maxHeight: navHeight,
        minHeight: navHeight,
        paddingRight: "$quarter",
        paddingLeft: "$quarter",
        backgroundColor: "$surfaceBackgroundPrimary",
        boxShadow: "$dropdown",
        position: "sticky",
        top: 0,
        zIndex: "$sticky",
        "@laptop": {
          paddingRight: "$one",
          paddingLeft: "$one"
        },
        "@desktop": {
          paddingRight: "$three",
          paddingLeft: "$three"
        }
      }
    },
    enableSkipToContent && /* @__PURE__ */ React47.createElement(
      SkipContentBox,
      {
        css: {
          top: isMobile ? "-180%" : "-150%"
        }
      },
      /* @__PURE__ */ React47.createElement(
        TextAction,
        {
          css: {
            padding: "$half",
            borderColor: "$onSurfaceBorderSubdued",
            borderWidth: "thin",
            backgroundColor: "$surfaceBackgroundPrimary",
            "&&:focus": {
              outlineOffset: "0"
            }
          },
          href: "#main-content"
        },
        formatMessage({ id: "SKIP_TO_CONTENT_MESSAGE" })
      )
    ),
    children
  );
};

// src/components/app-nav-bar/app-nav.nav.component.tsx
import React48 from "react";
import { StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
var AppBarNav = ({ children }) => /* @__PURE__ */ React48.createElement(StackLayout4, { as: "nav", orientation: "horizontal", verticalAlignment: "stretch" }, children);

// src/components/app-nav-bar/app-nav.nav-list.component.tsx
import React49 from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import { StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";
var AppBarNavList = ({ children }) => {
  const { formatMessage } = useIntl17();
  return /* @__PURE__ */ React49.createElement(
    StackLayout5,
    {
      as: "ul",
      orientation: "horizontal",
      "aria-label": formatMessage({ id: "MAIN_NAVIGATION_LIST_LABEL" }),
      horizontalAlignment: "spaceBetween",
      css: { alignItems: "stretch" }
    },
    children
  );
};

// src/components/app-nav-bar/app-nav.component.tsx
var AppBarComponent = ({
  children,
  navHeight,
  enableSkipToContent
}) => /* @__PURE__ */ React50.createElement(AppBarHeader, { navHeight, enableSkipToContent }, /* @__PURE__ */ React50.createElement(AppBarNav, null, /* @__PURE__ */ React50.createElement(AppBarNavList, null, children)));

// src/components/app-nav-bar/app-nav.nav-items.component.tsx
import React51 from "react";
import { NavLink } from "@leagueplatform/routing";
import {
  Box as Box21,
  css as css10,
  Flex as Flex21,
  genesisStyled as genesisStyled15,
  Link as Link4
} from "@leagueplatform/genesis-commons";
var StyledLink2 = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React51.createElement(
    Link4,
    __spreadValues({
      display: "flex",
      position: "relative",
      alignSelf: "stretch",
      alignItems: "center",
      color: "onSurface.text.subdued",
      fontSize: "subtitle2",
      textAlign: "center",
      paddingX: { _: (props == null ? void 0 : props.isMobile) ? 0 : "quarter", laptop: "half" },
      textDecoration: "none !important",
      hoverStyle: { color: "onSurface.text.primary" }
    }, props),
    /* @__PURE__ */ React51.createElement(Box21, { as: "span" }, children)
  );
};
var StyledNavLink = genesisStyled15((props) => /* @__PURE__ */ React51.createElement(StyledLink2, __spreadValues({ as: NavLink }, props)))(
  (props) => {
    var _a;
    return css10({
      '&[aria-current="page"]': {
        color: !((_a = props.hoverStyle) == null ? void 0 : _a.color) ? "onSurface.text.primary" : props.hoverStyle.color
      },
      '&[aria-current="page"]:after': {
        content: '""',
        display: "block",
        position: "absolute",
        bottom: -1,
        left: 0,
        backgroundColor: (props == null ? void 0 : props.isMobile) ? "transparent" : "primary.background.hovered",
        height: "quarter",
        borderRadius: "large",
        width: "100%"
      }
    });
  }
);
var AppBarItem = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React51.createElement(Flex21, __spreadValues({ as: "li", flexGrow: 1, alignSelf: "stretch" }, props), children);
};
var AppBarLink = (_a) => {
  var _b = _a, {
    children,
    listItemProps
  } = _b, props = __objRest(_b, [
    "children",
    "listItemProps"
  ]);
  return /* @__PURE__ */ React51.createElement(AppBarItem, __spreadValues({}, listItemProps), /* @__PURE__ */ React51.createElement(StyledLink2, __spreadValues({}, props), children));
};
var AppBarNavLink = (_a) => {
  var _b = _a, {
    children,
    listItemProps
  } = _b, props = __objRest(_b, [
    "children",
    "listItemProps"
  ]);
  return /* @__PURE__ */ React51.createElement(AppBarItem, __spreadValues({}, listItemProps), /* @__PURE__ */ React51.createElement(StyledNavLink, __spreadValues({}, props), children));
};

// src/components/highlight-banner/highlight-banner.component.jsx
import React52 from "react";
import PropTypes8 from "prop-types";
import {
  Flex as Flex22,
  Box as Box22,
  SubtitleTwo as SubtitleTwo2,
  Overline as Overline3,
  Image as Image7
} from "@leagueplatform/genesis-commons";
var HighlightBanner = ({
  title,
  icon,
  backgroundColor,
  color,
  marginBottom,
  children
}) => /* @__PURE__ */ React52.createElement(
  Box22,
  {
    backgroundColor,
    borderRadius: "medium",
    marginBottom,
    padding: "one"
  },
  /* @__PURE__ */ React52.createElement(Flex22, { alignItems: "center" }, icon && /* @__PURE__ */ React52.createElement(Image7, { src: icon, alt: "", width: "oneAndHalf", marginRight: "half" }), /* @__PURE__ */ React52.createElement(Overline3, { as: "p", color }, title)),
  /* @__PURE__ */ React52.createElement(SubtitleTwo2, { as: "p", fontWeight: "regular", marginTop: "half", color }, children)
);
HighlightBanner.propTypes = {
  title: PropTypes8.string.isRequired,
  icon: PropTypes8.string,
  backgroundColor: PropTypes8.string,
  color: PropTypes8.string,
  marginBottom: PropTypes8.string,
  children: PropTypes8.node.isRequired
};
HighlightBanner.defaultProps = {
  icon: null,
  backgroundColor: "highlight.background.subdued",
  color: "onSurface.text.primary",
  marginBottom: "twoAndHalf"
};

// src/components/internal-or-external-link-button/internal-or-external-link-button.component.tsx
import React53, { forwardRef as forwardRef2 } from "react";
import { Link as RouterLink3 } from "@leagueplatform/routing";
import {
  Button as Button4
} from "@leagueplatform/genesis-core";
import { isExternalUrl } from "@leagueplatform/web-common";
import { getInitializationConfig } from "@leagueplatform/core";
var InternalOrExternalLinkButton = forwardRef2((_a, ref) => {
  var _b = _a, { href, children, baseComponent, onClick } = _b, linkProps = __objRest(_b, ["href", "children", "baseComponent", "onClick"]);
  const { isExternalUrl: isExternalLink = isExternalUrl(href) } = linkProps;
  const isExternalUrlOrPhoneNumber = isExternalLink || href.includes("tel:");
  const Component = baseComponent != null ? baseComponent : Button4;
  return /* @__PURE__ */ React53.createElement(
    Component,
    __spreadValues({
      ref,
      as: isExternalUrlOrPhoneNumber ? "a" : RouterLink3,
      to: isExternalUrlOrPhoneNumber ? void 0 : href,
      href: isExternalUrlOrPhoneNumber ? href : void 0,
      target: isExternalLink ? "_blank" : void 0,
      rel: isExternalLink ? "noopener noreferrer" : void 0,
      onClick: (e) => {
        if (isExternalLink) {
          e.preventDefault();
          getInitializationConfig().customMethods.handleLink(href);
        }
        if (onClick) {
          onClick(e);
        }
      }
    }, linkProps),
    children
  );
});

// src/components/skeleton-box/skeleton-box.component.tsx
import React54 from "react";
import {
  Box as Box23,
  Flex as Flex23,
  genesisStyled as genesisStyled16
} from "@leagueplatform/genesis-commons";
var SkeletonBox = genesisStyled16(
  Box23
)`
    width: ${(props) => props.width || "100%"};
    background-color: ${(props) => props.backgroundColor || props.theme.colors.surface.background.secondary};
    height: ${(props) => props.height};
    border-radius: ${(props) => props.borderRadius || "6px"};
    margin-bottom: ${(props) => props.marginBottom || "0px"};
    margin-top: ${(props) => props.marginTop || "0px"};
    padding-top: ${(props) => props.paddingTop || "0px"};
    padding-bottom: ${(props) => props.paddingBottom || "0px"};
    z-index: 0;
    position: relative;
    overflow: hidden;
    &:after {
      content: '';
      top: 0;
      transform: translateX(100%);
      width: 100%;
      height: ${(props) => props.height};
      position: absolute;
      z-index: 1;
      animation: slide 2s infinite;
      background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.4) 50%,
          rgba(128, 186, 232, 0) 99%,
          rgba(125, 185, 232, 0) 100%
      );
    }
    @keyframes slide {
      0% {
          transform: translateX(-100%);
      }
      100% {
          transform: translateX(100%);
      }
    }
`;
var SkeletonCardFlex = genesisStyled16(Flex23)`
  & > *:last-child {
      margin-right: 0em !important;
    }
  }
`;
var SkeletonCards = (_a) => {
  var _b = _a, {
    numCards = 1,
    height = "100px"
  } = _b, props = __objRest(_b, [
    "numCards",
    "height"
  ]);
  const cards = [];
  for (let i = 0; i < numCards; i += 1)
    cards.push(
      /* @__PURE__ */ React54.createElement(
        SkeletonBox,
        __spreadValues({
          key: i,
          marginRight: "one",
          height
        }, props)
      )
    );
  return /* @__PURE__ */ React54.createElement(SkeletonCardFlex, { justifyContent: "space-between" }, cards);
};

// src/components/user-dropdown/user-dropdown.component.tsx
import React59, { useRef as useRef4, useState as useState3 } from "react";
import { Flex as Flex24 } from "@leagueplatform/genesis-commons";
import { trackAnalyticsEvent as trackAnalyticsEvent3 } from "@leagueplatform/analytics";
import { useHandleDropdown } from "@leagueplatform/web-common";
import { queryHelpers as queryHelpers3, useMediaQuery as useMediaQuery3 } from "@leagueplatform/genesis-core";

// src/components/user-dropdown/user-dropdown.user-bar.component.tsx
import React55 from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { Button as Button5, Icon as Icon4, VisuallyHidden as VisuallyHidden7 } from "@leagueplatform/genesis-core";
var UserBar = (_a) => {
  var _b = _a, { label, isOpen, onClick } = _b, props = __objRest(_b, ["label", "isOpen", "onClick"]);
  const { formatMessage } = useIntl18();
  return /* @__PURE__ */ React55.createElement(
    Button5,
    __spreadValues({
      id: "user_dropdown_menu_button",
      onClick,
      "aria-haspopup": "dialog",
      "aria-expanded": isOpen,
      "aria-controls": "user_dropdown_menu",
      size: "toolbar",
      priority: "tertiary",
      css: {
        fontSize: "$bodyTwo",
        fontWeight: 500,
        borderRadius: "$none",
        border: "$none",
        span: { display: "flex", alignItems: "center" },
        "&:hover": {
          color: "$onSurfaceTextPrimary"
        }
      }
    }, props),
    label,
    /* @__PURE__ */ React55.createElement(VisuallyHidden7, null, formatMessage({ id: "USER_DROPDOWN_BTN_LABEL" })),
    /* @__PURE__ */ React55.createElement(
      Icon4,
      {
        icon: "interfaceChevronDown",
        size: "$one",
        css: {
          marginLeft: "$quarter",
          transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          transition: "transform 0.5s ease"
        }
      }
    )
  );
};

// src/components/user-dropdown/user-dropdown.dropdown.component.tsx
import React58, { useRef as useRef3 } from "react";
import { EVENT_NAME as EVENT_NAME2, trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
import { Box as Box26 } from "@leagueplatform/genesis-core";
import {
  useListItemsFocusHook,
  usePreventScroll
} from "@leagueplatform/web-common";

// src/components/user-dropdown/user-dropdown.dropdown-styles.ts
import { Box as Box24, css as css11, genesisStyled as genesisStyled17 } from "@leagueplatform/genesis-commons";
var DROPDOWN_MEGA_TOOLTIP_WIDTH = 260;
var DROPDOWN_MEGA_TOOLTIP_MOBILE_WIDTH = "100%";
var DROPDOWN_MEGA_TOOLTIP_MOBILE_HEIGHT = "337px";
var SPACE_BELOW_BUTTON_AND_ARROW = "62px";
var MOBILE_SPACE_BELOW_BUTTON_AND_ARROW = "48px";
var BORDER_WIDTH = 10;
var OVERLAY_Z_INDEX = 998;
var TOOLTIP_Z_INDEX = 999;
var DropdownMegaTooltipBase = genesisStyled17(Box24)(
  ({ isOpen }) => css11({
    padding: "one",
    transitionProperty: "opacity",
    transitionDuration: "250ms",
    animationTimingFunction: "ease",
    opacity: isOpen ? "1" : "0",
    listStyle: "none",
    position: "absolute",
    display: isOpen ? "flex" : "auto",
    flexDirection: "column",
    border: "thin",
    backgroundColor: "interactive.background.default",
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "9px",
    zIndex: TOOLTIP_Z_INDEX,
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: "100%",
      width: 0,
      height: 0,
      borderWidth: `${BORDER_WIDTH}px`,
      borderStyle: "solid",
      borderColor: "transparent",
      borderBottomColor: "interactive.background.default",
      borderTop: "none"
    }
  })
);
var DropdownMegaTooltip = genesisStyled17(DropdownMegaTooltipBase)(
  css11({
    gap: "0",
    right: "0",
    top: SPACE_BELOW_BUTTON_AND_ARROW,
    marginRight: "-10px",
    minHeight: "auto",
    width: DROPDOWN_MEGA_TOOLTIP_WIDTH,
    "&:after": {
      right: "10px"
    }
  })
);
var DropdownMegaTooltipMobile = genesisStyled17(DropdownMegaTooltipBase)(
  css11({
    gap: "one",
    left: 0,
    top: MOBILE_SPACE_BELOW_BUTTON_AND_ARROW,
    minHeight: DROPDOWN_MEGA_TOOLTIP_MOBILE_HEIGHT,
    width: DROPDOWN_MEGA_TOOLTIP_MOBILE_WIDTH,
    borderRadius: "0 0 9px 9px"
  })
);
var Overlay = genesisStyled17(Box24)({
  position: "fixed",
  top: MOBILE_SPACE_BELOW_BUTTON_AND_ARROW,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: OVERLAY_Z_INDEX
});

// src/components/user-dropdown/user-dropdown.dropdown-list.component.tsx
import React57 from "react";

// src/components/user-dropdown/user-dropdown.dropdown-item.component.tsx
import React56 from "react";
import {
  Box as Box25,
  css as css12,
  genesisStyled as genesisStyled18,
  Link as Link5,
  VisuallyHidden as VisuallyHidden8
} from "@leagueplatform/genesis-commons";
import { Divider } from "@leagueplatform/genesis-core";
import { Link as RouterLink4 } from "@leagueplatform/routing";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
var NotificationDot = genesisStyled18(Box25)(
  () => css12({
    borderRadius: "circle",
    position: "absolute",
    top: "50%",
    right: "minusOne",
    backgroundColor: "critical.icon",
    width: "half",
    height: "half",
    transform: "translateY(-50%)"
  })
);
var UserDropdownItem = React56.forwardRef(
  ({
    to,
    text,
    isMobile,
    onClick = () => {
    },
    target,
    hasNotification,
    linkProps = {},
    isLastElementInSection
  }, ref) => {
    const { formatMessage } = useIntl19();
    const isExternalLink = to && /^[^(/|..)]/.test(to);
    const Component = (() => {
      if (!to)
        return "button";
      if (isExternalLink)
        return Link5;
      return RouterLink4;
    })();
    return /* @__PURE__ */ React56.createElement(Box25, { as: "li" }, /* @__PURE__ */ React56.createElement(
      Link5,
      __spreadValues({
        as: Component,
        to: !isExternalLink ? to : void 0,
        href: isExternalLink ? to : void 0,
        ref,
        hoverStyle: {
          textDecoration: "none !important",
          backgroundColor: "interactive.background.hovered"
        },
        fontSize: "body2",
        lineHeight: "body2",
        fontWeight: isMobile ? "bold" : "regular",
        color: isMobile ? "interactive.action.subdued" : "onSurface.text.primary",
        display: "block",
        padding: "half",
        marginBottom: "quarter",
        border: "none",
        backgroundColor: "transparent",
        width: "100%",
        textAlign: "left",
        onClick,
        target,
        "aria-describedby": hasNotification ? "dependent-notification-message" : ""
      }, linkProps),
      /* @__PURE__ */ React56.createElement(Box25, { as: "span", position: "relative" }, formatMessage({ id: text }), target === "_blank" && /* @__PURE__ */ React56.createElement(VisuallyHidden8, { "data-testid": "new-tab-msg" }, formatMessage({ id: "OPENS_IN_A_NEW_TAB" })), hasNotification && /* @__PURE__ */ React56.createElement(
        NotificationDot,
        {
          "aria-hidden": true,
          id: "dependent-notification-message",
          "aria-label": formatMessage({
            id: "DEPENDENT_NOTIFICATION_MESSAGE"
          })
        }
      ))
    ), isLastElementInSection && /* @__PURE__ */ React56.createElement(
      Divider,
      {
        css: __spreadValues({
          marginLeft: "$half",
          marginRight: "$half",
          width: "unset",
          borderWidth: "1px"
        }, isMobile && { marginTop: "$oneAndHalf" })
      }
    ));
  }
);

// src/components/user-dropdown/user-dropdown.dropdown-list.component.tsx
var DropdownList = ({ dropdownItemsConfig, onDropdownClick, isMobile, refsMenuItems }) => {
  const handleDropdownItemClick = (event, dropdownItem) => {
    onDropdownClick(dropdownItem.text);
    if (dropdownItem.onClick) {
      dropdownItem.onClick(event);
      event.preventDefault();
    }
  };
  return /* @__PURE__ */ React57.createElement(React57.Fragment, null, dropdownItemsConfig.map((section, sectionIndex) => {
    const items = section.map(
      (dropdownItem, elementIndex) => /* @__PURE__ */ React57.createElement(
        UserDropdownItem,
        __spreadProps(__spreadValues({}, dropdownItem), {
          isMobile,
          key: dropdownItem.text,
          onClick: (event) => handleDropdownItemClick(event, dropdownItem),
          ref: (node) => {
            if (node) {
              refsMenuItems.push(node);
            }
          },
          isLastElementInSection: sectionIndex < dropdownItemsConfig.length - 1 && elementIndex === section.length - 1
        })
      )
    );
    return items;
  }));
};

// src/components/user-dropdown/user-dropdown.dropdown.component.tsx
var UserDropdown = ({
  isOpen,
  isMobile,
  setIsOpen,
  dropdownItemsConfig = [],
  getDropdownItemAnalyticsProps
}) => {
  const refsMenuItems = [];
  const refContainer = useRef3();
  useListItemsFocusHook(isOpen, refsMenuItems, refContainer);
  usePreventScroll(isMobile && isOpen);
  const formattedName = (action) => {
    var _a;
    return (_a = action == null ? void 0 : action.toLocaleLowerCase()) == null ? void 0 : _a.replace(/_/g, " ");
  };
  const onDropdownClick = (action) => {
    setIsOpen(false);
    trackAnalyticsEvent2(
      EVENT_NAME2.BUTTON_CLICKED,
      getDropdownItemAnalyticsProps == null ? void 0 : getDropdownItemAnalyticsProps(formattedName(action))
    );
  };
  if (isMobile) {
    return /* @__PURE__ */ React58.createElement(Box26, null, isOpen && /* @__PURE__ */ React58.createElement(Overlay, { onClick: () => setIsOpen(false) }), /* @__PURE__ */ React58.createElement(
      DropdownMegaTooltipMobile,
      {
        as: "ul",
        isOpen,
        isMobile,
        id: "user_dropdown_menu",
        role: "dialog",
        ref: refContainer,
        hidden: !isOpen
      },
      /* @__PURE__ */ React58.createElement(
        DropdownList,
        {
          dropdownItemsConfig,
          onDropdownClick,
          isMobile,
          refsMenuItems
        }
      )
    ));
  }
  return /* @__PURE__ */ React58.createElement(
    DropdownMegaTooltip,
    {
      as: "ul",
      isOpen,
      isMobile,
      id: "user_dropdown_menu",
      role: "dialog",
      ref: refContainer,
      hidden: !isOpen
    },
    /* @__PURE__ */ React58.createElement(
      DropdownList,
      {
        dropdownItemsConfig,
        onDropdownClick,
        isMobile,
        refsMenuItems
      }
    )
  );
};

// src/components/user-dropdown/user-dropdown.component.tsx
var UserDropdownComponent = ({
  label,
  dropdownItemsConfig = [],
  userBarProps = {},
  userBarAnalyticsProps,
  enableMobileRedesign = false,
  getDropdownItemAnalyticsProps = (action) => {
    var _a, _b;
    return {
      detail: action,
      product_area: (_a = userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props) == null ? void 0 : _a.product_area,
      screen_name: (_b = userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props) == null ? void 0 : _b.detail
    };
  }
}) => {
  const isMobile = Boolean(
    useMediaQuery3(queryHelpers3.down("mobileLandscape")) && enableMobileRedesign
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState3(false);
  const dropdownRef = useRef4(null);
  useHandleDropdown({
    isOpen: isDropdownOpen,
    setIsOpen: setIsDropdownOpen,
    ref: dropdownRef
  });
  const toggleDropdown = (event) => {
    if (isDropdownOpen === false) {
      trackAnalyticsEvent3(
        (userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.name) || "",
        userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props
      );
    }
    event.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };
  return /* @__PURE__ */ React59.createElement(
    Flex24,
    {
      color: "onSurface.text.primary",
      justifyContent: "center",
      position: isMobile ? "static" : "relative",
      ref: dropdownRef
    },
    /* @__PURE__ */ React59.createElement(
      UserBar,
      __spreadValues({
        label,
        isOpen: isDropdownOpen,
        onClick: toggleDropdown
      }, userBarProps)
    ),
    /* @__PURE__ */ React59.createElement(
      UserDropdown,
      {
        isOpen: isDropdownOpen,
        isMobile,
        setIsOpen: setIsDropdownOpen,
        dropdownItemsConfig,
        getDropdownItemAnalyticsProps
      }
    )
  );
};

// src/components/animations/fade-and-grow.tsx
import React60 from "react";
import { Box as Box27, css as css13, genesisStyled as genesisStyled19 } from "@leagueplatform/genesis-commons";
import { Transition as Transition2 } from "react-transition-group";
var Element = genesisStyled19(Box27)(
  ({ stylesProp }) => css13(__spreadProps(__spreadValues({}, stylesProp), {
    opacity: 0
  }))
);
var transitionStyles = {
  entering: {
    opacity: 0,
    visibility: "visible",
    maxHeight: "90vh",
    overflow: "hidden"
  },
  entered: {
    opacity: 1,
    visibility: "visible",
    maxHeight: "90vh",
    overflowY: "auto"
  },
  exiting: {
    opacity: 0,
    visibility: "hidden",
    maxHeight: "0px",
    overflow: "hidden"
  },
  exited: {
    opacity: 0,
    visibility: "hidden",
    maxHeight: "0px"
  }
};
var FadeAndGrow = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => {
  const halfTime = duration / 2;
  return /* @__PURE__ */ React60.createElement(Transition2, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React60.createElement(
    Element,
    {
      stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
        overflow: "hidden",
        transition: `opacity ${halfTime}ms ease-in-out, max-height ${duration}ms ease-in-out ${halfTime}ms, visibility ${duration}ms ease-in-out ${halfTime}ms`
      }),
      style: __spreadValues({}, transitionStyles[state])
    },
    children && children
  ));
};

// src/components/animations/fade-in.tsx
import React61 from "react";
import { Box as Box28, css as css14, genesisStyled as genesisStyled20 } from "@leagueplatform/genesis-commons";
import { Transition as Transition3 } from "react-transition-group";
var Element2 = genesisStyled20(Box28)(
  ({ stylesProp }) => css14(__spreadProps(__spreadValues({}, stylesProp), {
    opacity: 0
  }))
);
var transitionStyles2 = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
};
var FadeIn = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => /* @__PURE__ */ React61.createElement(Transition3, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React61.createElement(
  Element2,
  {
    stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
      transition: `opacity ${duration}ms ease-in-out`
    }),
    style: __spreadValues({}, transitionStyles2[state])
  },
  children && children
));

// src/components/animations/grow.tsx
import React62 from "react";
import { Box as Box29, css as css15, genesisStyled as genesisStyled21 } from "@leagueplatform/genesis-commons";
import { Transition as Transition4 } from "react-transition-group";
var Element3 = genesisStyled21(Box29)(
  ({ styles }) => css15(__spreadProps(__spreadValues({}, styles), {
    width: 0,
    overflow: "hidden"
  }))
);
var transitionStyles3 = {
  entering: { width: "100%" },
  entered: { width: "100%" },
  exiting: { width: 0 },
  exited: { width: 0 }
};
var Grow = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => /* @__PURE__ */ React62.createElement(Transition4, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React62.createElement(
  Element3,
  {
    styles: __spreadProps(__spreadValues({}, stylesProp), {
      transition: `width ${duration}ms ease-in-out`
    }),
    style: __spreadValues({}, transitionStyles3[state])
  },
  children && children
));

// src/components/animations/slide-in-horizontal.tsx
import React63 from "react";
import { Box as Box30, css as css16, genesisStyled as genesisStyled22 } from "@leagueplatform/genesis-commons";
import { Transition as Transition5 } from "react-transition-group";
var Element4 = genesisStyled22(Box30)(
  ({ stylesProp }) => css16(__spreadValues({}, stylesProp))
);
var SlideInHorizontal = ({
  isActive,
  stylesProp,
  duration,
  distance = "-100%",
  children = null
}) => {
  const transitionStyles4 = {
    entering: { transform: `translateX(0)` },
    entered: { transform: `translateX(0)` },
    exiting: { transform: `translateX(0)` },
    exited: { transform: `translateX(${distance})` }
  };
  return /* @__PURE__ */ React63.createElement(Transition5, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React63.createElement(
    Element4,
    {
      stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
        transition: `transform ${duration}ms ease-in-out`
      }),
      style: __spreadValues({}, transitionStyles4[state])
    },
    children && children
  ));
};

// src/components/language-selector-dropdown/language-selector.component.jsx
import React67, { useState as useState4, useRef as useRef5, useContext } from "react";
import { Flex as Flex27 } from "@leagueplatform/genesis-commons";
import { LocaleContext } from "@leagueplatform/locales";
import { useHandleDropdown as useHandleDropdown2 } from "@leagueplatform/web-common";

// src/components/language-selector-dropdown/language-selector-bar.component.jsx
import React64 from "react";
import PropTypes9 from "prop-types";
import { Flex as Flex25, Text, Image as Image8 } from "@leagueplatform/genesis-commons";
import CHEVRON from "./assets/chevron-down.svg";
var LanguageBar = ({ onClick, isOpen, selectedLanguage }) => {
  let shortLocale = selectedLanguage;
  if (selectedLanguage.includes("-")) {
    shortLocale = selectedLanguage.substring(0, selectedLanguage.indexOf("-"));
  }
  return /* @__PURE__ */ React64.createElement(
    Flex25,
    {
      as: "button",
      background: "none",
      onClick,
      border: "none",
      alignItems: "center",
      "aria-haspopup": "true",
      "aria-expanded": isOpen,
      "aria-controls": "language_selector_dropdown_menu",
      focusStyle: {
        outline: 0,
        boxShadow: "focusRing",
        borderWidth: "thin",
        borderColor: "decorative.brand.primary.bright"
      },
      cursor: "pointer"
    },
    /* @__PURE__ */ React64.createElement(
      Text,
      {
        as: "p",
        color: "onSurface.text.subdued",
        fontSize: "subtitle3",
        display: "inline",
        marginRight: "half",
        fontWeight: "medium",
        hoverStyle: {
          color: "onSurface.text.primary"
        }
      },
      shortLocale.toUpperCase()
    ),
    /* @__PURE__ */ React64.createElement(
      Image8,
      {
        src: CHEVRON,
        alt: "",
        height: "threeQuarters",
        transition: "transform 0.5s ease",
        transform: isOpen ? "rotate(180deg)" : "rotate(0)",
        role: "presentation"
      }
    )
  );
};
LanguageBar.defaultProps = { isOpen: false };
LanguageBar.propTypes = {
  isOpen: PropTypes9.bool,
  onClick: PropTypes9.func.isRequired,
  selectedLanguage: PropTypes9.string.isRequired
};

// src/components/language-selector-dropdown/language-selector-dropdown.component.tsx
import React66 from "react";
import {
  DEFAULT_LOCALE,
  supportedLocaleMapping
} from "@leagueplatform/locales";

// src/components/language-selector-dropdown/language-selector-dropdown-item.component.jsx
import React65 from "react";
import PropTypes10 from "prop-types";
import { Box as Box31, Image as Image9, Flex as Flex26 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl20, FullNameLocaleList } from "@leagueplatform/locales";
import CHECKMARK from "./assets/checkmark.svg";
var DropdownItem = ({ setLanguage, isSelected, locale }) => {
  const { formatMessage } = useIntl20();
  return /* @__PURE__ */ React65.createElement(Box31, { as: "li", role: "menuitem" }, /* @__PURE__ */ React65.createElement(
    Flex26,
    {
      as: "button",
      href: "#",
      lang: locale,
      fontSize: "body2",
      lineHeight: "body2",
      fontWeight: "regular",
      color: "onSurface.text.primary",
      padding: "half",
      marginBottom: "quarter",
      border: "none",
      backgroundColor: "transparent",
      width: "100%",
      textAlign: "left",
      hoverStyle: {
        textDecoration: "none !important",
        backgroundColor: "highlight.background.subdued",
        cursor: "pointer"
      },
      alignItems: "center",
      onClick: setLanguage
    },
    formatMessage({ id: FullNameLocaleList[locale] }),
    isSelected && /* @__PURE__ */ React65.createElement(Image9, { src: CHECKMARK, alt: "", height: "9px", paddingLeft: "half" })
  ));
};
DropdownItem.defaultProps = {
  isSelected: false
};
DropdownItem.propTypes = {
  locale: PropTypes10.string.isRequired,
  setLanguage: PropTypes10.func.isRequired,
  isSelected: PropTypes10.bool
};

// src/components/language-selector-dropdown/language-selector-dropdown.constants.ts
var DROPDOWN_MEGA_TOOLTIP_WIDTH2 = 250;
var SPACE_BELOW_BUTTON_AND_ARROW2 = "62px";
var SPACE_RIGHT_OF_DROPDOWN = "-35px";
var BORDER_WIDTH2 = 10;

// src/components/language-selector-dropdown/dropdown-tooltip.component.ts
import { Box as Box32, genesisStyled as genesisStyled23, css as css17 } from "@leagueplatform/genesis-commons";
var DropdownTooltip = genesisStyled23(Box32)(
  ({ isOpen }) => css17({
    transitionProperty: "opacity",
    transitionDuration: "250ms",
    animationTimingFunction: "ease",
    opacity: isOpen ? "1" : "0",
    "&:after": {
      content: '""',
      backgroundColor: "transparent",
      display: "block",
      position: "absolute",
      left: `calc(80% - ${BORDER_WIDTH2}px)`,
      bottom: "100%",
      width: 0,
      height: 0,
      borderWidth: `${BORDER_WIDTH2}px`,
      borderStyle: "solid",
      borderColor: "transparent",
      borderBottomColor: "surface.background.primary",
      borderTop: "none"
    }
  })
);

// src/components/language-selector-dropdown/language-selector-dropdown.component.tsx
var Dropdown = ({
  isOpen = false,
  setLanguage,
  selectedLanguage,
  countryCode
}) => /* @__PURE__ */ React66.createElement(
  DropdownTooltip,
  {
    position: "absolute",
    as: "ul",
    width: DROPDOWN_MEGA_TOOLTIP_WIDTH2,
    backgroundColor: "surface.background.primary",
    boxShadow: "dropdown",
    border: "thin",
    top: SPACE_BELOW_BUTTON_AND_ARROW2,
    right: SPACE_RIGHT_OF_DROPDOWN,
    borderRadius: "medium",
    padding: "one",
    isOpen,
    id: "language_selector_dropdown_menu",
    role: "menu",
    hidden: !isOpen
  },
  supportedLocaleMapping[countryCode] ? supportedLocaleMapping[countryCode].map((locale) => /* @__PURE__ */ React66.createElement(
    DropdownItem,
    {
      locale,
      isSelected: selectedLanguage === locale,
      key: locale,
      setLanguage: () => {
        setLanguage(locale);
        document.location.reload();
      }
    }
  )) : /* @__PURE__ */ React66.createElement(
    DropdownItem,
    {
      locale: DEFAULT_LOCALE,
      isSelected: selectedLanguage === DEFAULT_LOCALE,
      setLanguage: () => {
        setLanguage(DEFAULT_LOCALE);
      }
    }
  )
);

// src/components/language-selector-dropdown/use-user-country-code.hook.js
import {
  getGroup,
  GET_GROUP_MESSAGE_TYPE,
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { useQuery } from "react-query";
var getGroupId = (userProfileData) => {
  var _a;
  return (_a = userProfileData == null ? void 0 : userProfileData.groups) == null ? void 0 : _a.find(
    (group) => group.state === "active" || group.state === "initial"
  ).group_id;
};
function useUserCountryCode() {
  var _a, _b;
  const groupIdQuery = useQuery(
    [GET_USER_PROFILE_MESSAGE_TYPE],
    () => getUserProfile(),
    { select: (data) => getGroupId(data) }
  );
  const groupMessageTypeQuery = useQuery(
    [GET_GROUP_MESSAGE_TYPE],
    () => getGroup(String(groupIdQuery.data)),
    { enabled: !!groupIdQuery.data }
  );
  return (_b = (_a = groupMessageTypeQuery == null ? void 0 : groupMessageTypeQuery.data) == null ? void 0 : _a.group) == null ? void 0 : _b.country_code;
}

// src/components/language-selector-dropdown/language-selector.component.jsx
var LanguageSelector = () => {
  const { locale, setLocale } = useContext(LocaleContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState4(false);
  const dropdownRef = useRef5(null);
  const countryCode = useUserCountryCode();
  useHandleDropdown2({
    isOpen: isDropdownOpen,
    setIsOpen: setIsDropdownOpen,
    ref: dropdownRef
  });
  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };
  return /* @__PURE__ */ React67.createElement(
    Flex27,
    {
      justifyContent: "center",
      position: "relative",
      ref: dropdownRef,
      backgroundColor: "surface.background.primary"
    },
    /* @__PURE__ */ React67.createElement(
      LanguageBar,
      {
        "aria-controls": "language_dropdown_menu",
        "aria-expanded": isDropdownOpen,
        "aria-haspopup": "true",
        isOpen: isDropdownOpen,
        onClick: toggleDropdown,
        selectedLanguage: locale
      }
    ),
    /* @__PURE__ */ React67.createElement(
      Dropdown,
      {
        isOpen: isDropdownOpen,
        setIsOpen: setIsDropdownOpen,
        selectedLanguage: locale,
        setLanguage: setLocale,
        countryCode
      }
    )
  );
};

// src/components/progress-bar/progress-bar.component.tsx
import React68 from "react";
import {
  css as css18,
  Flex as Flex28,
  Box as Box33,
  genesisStyled as genesisStyled24,
  VisuallyHidden as VisuallyHidden9
} from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
import uniqueId from "lodash/uniqueId";
var Bar = genesisStyled24(Flex28)(
  css18({
    height: "1rem",
    minHeight: "10px",
    width: "100%",
    borderRadius: "59px",
    position: "relative",
    overflow: "hidden"
  })
);
var ProgressIndicator = genesisStyled24(Box33)(
  ({ customBackgroundColor, percentage, reducedMotion }) => css18({
    backgroundColor: customBackgroundColor,
    width: `${percentage}%`,
    transition: reducedMotion ? "width 2s linear" : "none",
    animation: reducedMotion ? "none" : "barWidth 1s ease-in-out forwards",
    "@keyframes barWidth": {
      from: {
        width: "0%"
      }
    }
  })
);
var ProgressBar = ({
  customBarFillColor = "primary.background.default",
  customBarBackgroundColor = "interactive.background.disabled",
  current,
  total = 100,
  // If no total is provided, assumption is current is a percentages so total would be 100
  screenReaderText = `${total ? Number(current / total * 100) : current}%`
}) => {
  const reducedMotion = usePrefersReducedMotion();
  const id = uniqueId("progress-bar");
  const currentAsPercentage = total ? Number(current / total * 100) : current;
  return /* @__PURE__ */ React68.createElement("div", null, /* @__PURE__ */ React68.createElement(VisuallyHidden9, null, /* @__PURE__ */ React68.createElement("label", { htmlFor: id }, screenReaderText), /* @__PURE__ */ React68.createElement("progress", { id, max: total, value: current })), /* @__PURE__ */ React68.createElement(
    Bar,
    {
      "data-testid": "progress-bar",
      "aria-hidden": true,
      backgroundColor: customBarBackgroundColor
    },
    /* @__PURE__ */ React68.createElement(
      ProgressIndicator,
      {
        customBackgroundColor: customBarFillColor,
        height: "100%",
        borderBottomRightRadius: "pill",
        borderTopRightRadius: "pill",
        percentage: currentAsPercentage,
        reducedMotion
      }
    )
  ));
};

// src/components/conditional-link-card/conditional-link-card.component.tsx
import React69, { useRef as useRef6 } from "react";
import {
  Flex as Flex29,
  css as css19,
  genesisStyled as genesisStyled25
} from "@leagueplatform/genesis-commons";
var LinkCardWrapper = genesisStyled25(Flex29)(
  css19({
    "&:hover, &:focus-within": {
      boxShadow: "focusOutline",
      borderRadius: "medium",
      cursor: "pointer"
    },
    a: {
      "&:hover": {
        textDecoration: "none"
      },
      "&:focus": {
        borderColor: "none",
        "&::before": {
          boxShadow: "none"
        }
      }
    }
  })
);
var ConditionalLinkCard = ({
  children,
  hasLink,
  cardStyle = {},
  linkRef,
  onClick = () => {
  }
}) => {
  const Card3 = hasLink ? LinkCardWrapper : Flex29;
  const cardRef = useRef6(null);
  const handleCardClick = () => {
    var _a;
    (_a = linkRef == null ? void 0 : linkRef.current) == null ? void 0 : _a.click();
    onClick();
  };
  return /* @__PURE__ */ React69.createElement(
    Card3,
    __spreadValues({
      ref: cardRef,
      flex: 1,
      boxShadow: "card",
      backgroundColor: "surface.background.primary",
      borderRadius: "large",
      borderStyle: "solid",
      onClick: handleCardClick
    }, cardStyle),
    children
  );
};

// src/components/conditional-link/conditional-link.component.tsx
import React70, { forwardRef as forwardRef3 } from "react";
import { TextAction as TextAction3 } from "@leagueplatform/genesis-core";
import { normalizeInternalUrl } from "@leagueplatform/web-common";
var ConditionalLink = forwardRef3((_a, ref) => {
  var _b = _a, { url, children, onClick = () => {
  } } = _b, linkProps = __objRest(_b, ["url", "children", "onClick"]);
  if (url) {
    const href = normalizeInternalUrl(url);
    return /* @__PURE__ */ React70.createElement(
      InternalOrExternalLinkButton,
      __spreadValues({
        baseComponent: TextAction3,
        onClick: (e) => {
          e.stopPropagation();
          onClick(e);
        },
        ref,
        href,
        css: {
          "&&": {
            all: "inherit"
          },
          "&:focus": {
            outline: "unset !important"
          }
        }
      }, linkProps),
      children
    );
  }
  return children;
});

// src/components/progress-ring/progress-ring.component.tsx
import React71 from "react";
import {
  css as css20,
  Flex as Flex30,
  genesisStyled as genesisStyled26,
  VisuallyHidden as VisuallyHidden10,
  Image as Image10,
  useTheme
} from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion as usePrefersReducedMotion2 } from "@leagueplatform/web-common";
import uniqueId2 from "lodash/uniqueId";
var ProgressRingWrapper = genesisStyled26("svg")(
  ({ width, height }) => css20({
    width,
    height,
    transform: "rotate(-90deg)"
  })
);
var Progress = genesisStyled26("circle")(
  ({ stroke, reducedMotion, dash, circumference }) => css20({
    fill: "transparent",
    stroke,
    strokeLinecap: "round",
    transition: reducedMotion ? "stroke-dasharray 2s linear" : "none",
    strokeDasharray: `${dash}, ${circumference - dash}`,
    animation: reducedMotion ? "none" : "dashArray 1s ease-in-out forwards",
    "@keyframes dashArray": {
      from: {
        strokeDasharray: `0, ${circumference}`
      }
    }
  })
);
var Track = genesisStyled26("circle")(
  ({ stroke }) => css20({
    fill: "transparent",
    stroke,
    strokeDasharray: 0
  })
);
var CenteredImageWrapper = genesisStyled26(Flex30)(
  css20({
    borderRadius: "circle",
    overflow: "hidden",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    alignItems: "center",
    justifyContent: "center"
  })
);
var ProgressRing = ({
  customRingFillColor = "primary.background.default",
  customRingBackgroundColor = "interactive.background.disabled",
  current,
  total,
  screenReaderText = `${Number(current / total * 100)}%`,
  image,
  size = 82,
  strokeWidth = 12,
  imageAltText
}) => {
  const { space } = useTheme();
  const reducedMotion = usePrefersReducedMotion2();
  const currentAsPercentage = Number(current / total * 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = Math.PI * radius * 2;
  const dash = currentAsPercentage * circumference / 100;
  const id = uniqueId2("progress-ring");
  return /* @__PURE__ */ React71.createElement("div", null, /* @__PURE__ */ React71.createElement(VisuallyHidden10, null, /* @__PURE__ */ React71.createElement("label", { htmlFor: id }, screenReaderText), /* @__PURE__ */ React71.createElement("progress", { id, max: total, value: current })), /* @__PURE__ */ React71.createElement(Flex30, { alignItems: "center", justifyContent: "center", position: "relative" }, /* @__PURE__ */ React71.createElement(ProgressRingWrapper, { width: size, height: size }, /* @__PURE__ */ React71.createElement(
    Track,
    {
      stroke: customRingBackgroundColor,
      strokeWidth: `${strokeWidth}px`,
      cx: size / 2,
      cy: size / 2,
      r: radius
    }
  ), /* @__PURE__ */ React71.createElement(
    Progress,
    {
      stroke: customRingFillColor,
      strokeWidth: `${strokeWidth}px`,
      cx: size / 2,
      cy: size / 2,
      r: radius,
      dash,
      circumference,
      reducedMotion
    }
  )), image && /* @__PURE__ */ React71.createElement(
    CenteredImageWrapper,
    {
      width: size - (strokeWidth + space.half) * 2,
      height: size - (strokeWidth + space.half) * 2
    },
    /* @__PURE__ */ React71.createElement(Image10, { src: image, alt: imageAltText })
  )));
};

// src/components/highlight-card/highlight-card.tsx
import * as React72 from "react";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import {
  Card,
  HeadingText as HeadingText3,
  StackLayout as StackLayout6,
  TextAction as TextAction4
} from "@leagueplatform/genesis-core";
function HighlightCard({
  title,
  seeMoreLink,
  children,
  onClick
}) {
  const { formatMessage } = useIntl21();
  return /* @__PURE__ */ React72.createElement(Card.Elevated, null, /* @__PURE__ */ React72.createElement(Card.Section, null, /* @__PURE__ */ React72.createElement(
    StackLayout6,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: { marginBottom: "$one" }
    },
    /* @__PURE__ */ React72.createElement(HeadingText3, { level: "3", size: "lg" }, title),
    /* @__PURE__ */ React72.createElement(
      TextAction4,
      {
        emphasis: "subtle",
        css: {
          typography: "$overline"
        },
        href: seeMoreLink,
        onClick
      },
      formatMessage({ id: "SEE_MORE" })
    )
  ), children));
}

// src/components/callout-banner/callout-banner.tsx
import * as React73 from "react";
import {
  StackLayout as StackLayout7,
  Card as Card2,
  Icon as Icon5
} from "@leagueplatform/genesis-core";
function CalloutBanner({ icon, label, children }) {
  return /* @__PURE__ */ React73.createElement(Card2.Flat, { backgroundColor: "highlight" }, /* @__PURE__ */ React73.createElement(Card2.Section, { padding: "$threeQuarters" }, /* @__PURE__ */ React73.createElement(
    StackLayout7,
    {
      orientation: "horizontal",
      spacing: "$half",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React73.createElement(
      Icon5,
      {
        css: {
          borderRadius: "$circle",
          backgroundColor: "$surfaceBackgroundPrimary",
          objectFit: "scale-down"
        },
        size: "$twoAndHalf",
        icon,
        label
      }
    ),
    children
  )));
}

// src/components/external-redirect/external-redirect.component.tsx
import React74 from "react";
var ExternalRedirect = ({ to }) => {
  React74.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

// src/components/badge/badge.component.tsx
import React76, { createElement as createElement11 } from "react";
import {
  StackLayout as StackLayout9
} from "@leagueplatform/genesis-core";

// src/components/icon-text/icon-text.component.tsx
import * as React75 from "react";
import {
  UtilityText,
  StackLayout as StackLayout8,
  Icon as Icon6
} from "@leagueplatform/genesis-core";
var IconText = ({ iconProps, text }) => /* @__PURE__ */ React75.createElement(
  StackLayout8,
  {
    orientation: "horizontal",
    spacing: "$quarter",
    verticalAlignment: "center"
  },
  /* @__PURE__ */ React75.createElement(Icon6, __spreadValues({ size: "$one" }, iconProps)),
  typeof text === "string" ? /* @__PURE__ */ React75.createElement(UtilityText, null, text) : text
);

// src/components/badge/badge.component.tsx
var defaultCss = {
  backgroundColor: "$successBackgroundSubdued",
  borderRadius: "$pill",
  color: "$onSurfaceTextPrimary",
  flex: "initial",
  fontWeight: "$semibold",
  padding: "$quarter $half",
  textDecoration: "none",
  typography: "$subtitleTwo",
  width: "fit-content"
};
var Badge = (_a) => {
  var _b = _a, {
    iconTextProps,
    children,
    css: css21 = {}
  } = _b, other = __objRest(_b, [
    "iconTextProps",
    "children",
    "css"
  ]);
  return /* @__PURE__ */ React76.createElement(
    StackLayout9,
    __spreadValues({
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter",
      css: __spreadValues(__spreadValues({}, defaultCss), css21)
    }, other),
    iconTextProps ? createElement11(IconText, iconTextProps) : children
  );
};

// src/components/calendar/calendar.tsx
import React77 from "react";
import {
  Button as Button6,
  Calendar,
  CalendarCell,
  CalendarGrid,
  CalendarGridBody,
  CalendarGridHeader,
  CalendarHeaderCell,
  Heading
} from "react-aria-components";
import {
  Box as Box34,
  styled as styled5,
  focusOutlineInner,
  Icon as Icon7,
  VisuallyHidden as VisuallyHidden11
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
var StyledCalendarFull = styled5(Box34, {
  ".calendar": {
    width: "677px",
    height: "100%",
    "@mobile": {
      width: "375px"
    }
  },
  ".calendar-grid-navigation": {
    display: "flex",
    justifyContent: "space-between"
  },
  ".calendar-grid-previous-button": {
    marginLeft: "$two",
    background: "none",
    border: "none"
  },
  ".calendar-grid-next-button": {
    marginRight: "$two",
    background: "none",
    border: "none"
  },
  ".calendar-grid-header": {
    marginBottom: "$half",
    tableLayout: "fixed",
    width: "100%",
    height: "100%"
  },
  ".calendar-grid-cell": {
    width: "44px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
    cursor: "pointer",
    "&[data-selected]": __spreadProps(__spreadValues({}, focusOutlineInner), {
      color: "$onSurfaceTextReversed",
      background: "$surfaceBackgroundTertiary",
      borderRadius: 9999
    }),
    "&[data-disabled], &[data-unavailable]": {
      color: "$onSurfaceTextSubdued",
      cursor: "not-allowed"
    }
  }
});
var CalendarView = (_a) => {
  var _b = _a, {
    ChevronRight,
    ChevronLeft,
    css: css21
  } = _b, props = __objRest(_b, [
    "ChevronRight",
    "ChevronLeft",
    "css"
  ]);
  const { formatMessage } = useIntl22();
  return /* @__PURE__ */ React77.createElement("div", null, /* @__PURE__ */ React77.createElement(StyledCalendarFull, { css: css21 }, /* @__PURE__ */ React77.createElement(Calendar, __spreadProps(__spreadValues({}, props), { className: "calendar" }), /* @__PURE__ */ React77.createElement("div", { className: "calendar-grid-navigation" }, /* @__PURE__ */ React77.createElement(Button6, { slot: "previous", className: "calendar-grid-previous-button" }, /* @__PURE__ */ React77.createElement(Icon7, __spreadValues({ icon: "interfaceChevronLeft" }, ChevronLeft)), /* @__PURE__ */ React77.createElement(VisuallyHidden11, null, formatMessage({ id: "PERVIOUS_MONTH" }))), /* @__PURE__ */ React77.createElement(Heading, null), /* @__PURE__ */ React77.createElement(Button6, { slot: "next", className: "calendar-grid-next-button" }, /* @__PURE__ */ React77.createElement(Icon7, __spreadValues({ icon: "interfaceChevronRight" }, ChevronRight)), /* @__PURE__ */ React77.createElement(VisuallyHidden11, null, formatMessage({ id: "NEXT_MONTH" })))), /* @__PURE__ */ React77.createElement(CalendarGrid, { weekdayStyle: "short", className: "calendar-grid-header" }, /* @__PURE__ */ React77.createElement(CalendarGridHeader, null, (day) => /* @__PURE__ */ React77.createElement(CalendarHeaderCell, null, day)), /* @__PURE__ */ React77.createElement(CalendarGridBody, { className: "calendar-grid-body" }, (date) => /* @__PURE__ */ React77.createElement(CalendarCell, { date, className: "calendar-grid-cell" }))))));
};

// src/components/action-menu/action-menu.component.tsx
import * as React78 from "react";
import { Box as Box35, UtilityText as UtilityText2 } from "@leagueplatform/genesis-core";

// src/hooks/use-action-menu-controls.hook.ts
import { useCallback as useCallback3, useEffect as useEffect4, useRef as useRef7, useState as useState5 } from "react";

// src/types/keyboard-actions.types.ts
var KeyboardActionTypes = /* @__PURE__ */ ((KeyboardActionTypes2) => {
  KeyboardActionTypes2["Close"] = "close";
  KeyboardActionTypes2["NextItem"] = "next-item";
  KeyboardActionTypes2["Open"] = "open";
  KeyboardActionTypes2["PrevItem"] = "prev-item";
  KeyboardActionTypes2["SelectItem"] = "select-item";
  return KeyboardActionTypes2;
})(KeyboardActionTypes || {});

// src/hooks/use-action-menu-controls.hook.ts
var keyboardActions = {
  menuOpen: [
    {
      key: "Escape" /* Escape */,
      action: "close" /* Close */
    },
    {
      key: "Tab" /* Tab */,
      action: "close" /* Close */
    },
    {
      key: "ArrowDown" /* ArrowDown */,
      action: "next-item" /* NextItem */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "ArrowUp" /* ArrowUp */,
      action: "prev-item" /* PrevItem */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "ArrowRight" /* ArrowRight */,
      action: "next-item" /* NextItem */
    },
    {
      key: "ArrowLeft" /* ArrowLeft */,
      action: "prev-item" /* PrevItem */
    },
    {
      key: "Enter" /* Enter */,
      action: "select-item" /* SelectItem */
    }
  ],
  menuClosed: [
    {
      key: " " /* Space */,
      action: "open" /* Open */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "Enter" /* Enter */,
      action: "open" /* Open */
    },
    {
      key: "ArrowDown" /* ArrowDown */,
      action: "open" /* Open */
    },
    {
      key: "ArrowUp" /* ArrowUp */,
      action: "open" /* Open */,
      options: {
        focusLastItem: true
      }
    }
  ]
};
var useActionMenuControls = () => {
  const [isMenuOpen, setIsMenuOpen] = useState5(false);
  const [selectedItemId, setSelectedItemId] = useState5();
  const menuButtonRef = useRef7();
  const menuItemRefs = useRef7([]);
  const setMenuItemRef = (item) => {
    if (item && !menuItemRefs.current.includes(item)) {
      menuItemRefs.current.push(item);
    }
  };
  const getFocusedMenuItemIndex = () => menuItemRefs.current.findIndex((item) => item === document.activeElement);
  const getFocusedMenuItem = () => menuItemRefs.current.find((item) => item === document.activeElement);
  const isMenuButtonFocused = useCallback3(
    () => menuButtonRef.current === document.activeElement,
    []
  );
  const focusOnNextItem = useCallback3((focusLastItem = false) => {
    var _a;
    const activeKey = getFocusedMenuItemIndex();
    const lastKey = menuItemRefs.current.length - 1;
    let keyToFocus = focusLastItem ? activeKey - 1 : activeKey + 1;
    if (keyToFocus < 0)
      keyToFocus = lastKey;
    if (keyToFocus > lastKey)
      keyToFocus = 0;
    (_a = menuItemRefs.current[keyToFocus]) == null ? void 0 : _a.focus();
  }, []);
  const openMenu = useCallback3(
    (focusLastItem = false) => {
      setIsMenuOpen(true);
      focusOnNextItem(focusLastItem);
    },
    [focusOnNextItem]
  );
  const closeMenu = useCallback3(() => {
    var _a;
    (_a = menuButtonRef.current) == null ? void 0 : _a.focus();
    setIsMenuOpen(false);
  }, []);
  const toggleMenuOpen = useCallback3(() => {
    if (isMenuOpen)
      closeMenu();
    else
      openMenu();
  }, [isMenuOpen, closeMenu, openMenu]);
  const onKeyDown = useCallback3(
    (event) => {
      var _a, _b, _c;
      const { Close, Open, PrevItem, NextItem, SelectItem } = KeyboardActionTypes;
      if (isMenuOpen) {
        const action = keyboardActions.menuOpen.find(
          (act) => act.key === event.key
        );
        if ((_a = action == null ? void 0 : action.options) == null ? void 0 : _a.preventDefault) {
          event.preventDefault();
        }
        if (action && action.action === Close) {
          closeMenu();
        }
        if (action && [NextItem, PrevItem].includes(action.action)) {
          focusOnNextItem(action.action === PrevItem);
        }
        if (action && action.action === SelectItem) {
          const activeItem = getFocusedMenuItem();
          if (activeItem && activeItem.id) {
            setSelectedItemId(activeItem.id);
          }
        }
      }
      if (!isMenuOpen && isMenuButtonFocused()) {
        const action = keyboardActions.menuClosed.find(
          (act) => act.key === event.key
        );
        if ((_b = action == null ? void 0 : action.options) == null ? void 0 : _b.preventDefault) {
          event.preventDefault();
        }
        if (action && action.action === Open) {
          openMenu((_c = action == null ? void 0 : action.options) == null ? void 0 : _c.focusLastItem);
        }
      }
    },
    [closeMenu, openMenu, isMenuOpen, focusOnNextItem, isMenuButtonFocused]
  );
  useEffect4(() => {
    if (isMenuOpen && selectedItemId !== void 0) {
      closeMenu();
    }
  }, [isMenuOpen, selectedItemId, closeMenu]);
  useEffect4(() => {
    if (isMenuOpen && isMenuButtonFocused() && !selectedItemId) {
      focusOnNextItem();
    }
  }, [isMenuOpen, isMenuButtonFocused, selectedItemId, focusOnNextItem]);
  useEffect4(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);
  return {
    isMenuOpen,
    menuButtonRef,
    menuItemRefs,
    openMenu,
    selectedItemId,
    setMenuItemRef,
    toggleMenuOpen,
    setSelectedItemId
  };
};

// src/components/action-menu/action-menu.styles.tsx
var ACTION_MENU_CLASS_NAMES = {
  ACTION_MENU: "GDS-action-menu",
  BUTTON: "GDS-action-menu-button",
  POPUP: "GDS-action-menu-popup",
  LIST: "GDS-action-menu-list",
  LABEL: "GDS-action-menu-label",
  LIST_ITEM: "GDS-action-menu-list-item"
};
var getCustomStylesForItem = (customStyles, itemClassName) => customStyles && customStyles[`.${itemClassName}`] ? customStyles[`.${itemClassName}`] : {};
var composeActionMenuStyles = (customStyles = {}) => {
  const { BUTTON, POPUP, LIST, LIST_ITEM, LABEL } = ACTION_MENU_CLASS_NAMES;
  const listItemStyles = {
    padding: "$threeQuarters $oneAndHalf",
    borderBottom: "solid $colors$onSurfaceBorderSubdued $borderWidths$thin",
    "&:last-child": {
      borderBottom: "none"
    }
  };
  return __spreadProps(__spreadValues({
    position: "relative",
    width: "max-content"
  }, customStyles), {
    [`.${BUTTON}`]: __spreadValues({
      '&[aria-expanded="false"] + .GDS-action-menu-popup': {
        display: "none"
      }
    }, getCustomStylesForItem(customStyles, BUTTON)),
    [`.${POPUP}`]: __spreadValues({
      position: "absolute",
      width: "max-content",
      height: "max-content",
      top: "calc(100% + $half)",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: "$dropdown",
      background: "$surfaceBackgroundPrimary",
      boxShadow: "$dropdown",
      borderRadius: "$huge"
    }, getCustomStylesForItem(customStyles, POPUP)),
    [`.${LIST}`]: __spreadValues({}, getCustomStylesForItem(customStyles, LIST)),
    [`.${LIST_ITEM}`]: __spreadValues(__spreadValues({}, listItemStyles), getCustomStylesForItem(customStyles, LIST_ITEM)),
    [`.${LABEL}`]: __spreadValues(__spreadValues({}, listItemStyles), getCustomStylesForItem(customStyles, LABEL))
  });
};

// src/components/action-menu/action-menu.component.tsx
var ActionMenu = ({
  className: customClassName = "",
  css: customCss = {},
  menuButton,
  menuId = "action-menu",
  menuItems = [],
  menuLabel = void 0,
  onSelectItem
}) => {
  const {
    isMenuOpen,
    menuButtonRef,
    selectedItemId,
    setMenuItemRef,
    toggleMenuOpen,
    setSelectedItemId
  } = useActionMenuControls();
  const menuButtonId = `${menuId}-button`;
  const menuLabelId = menuLabel ? `${menuId}-label` : "";
  const onClickMenuButton = () => {
    toggleMenuOpen();
  };
  const onClickMenuItem = (event) => {
    const selectedId = event.currentTarget.id;
    setSelectedItemId(selectedId);
  };
  const menuButtonProps = {
    id: menuButtonId,
    ref: menuButtonRef,
    onClick: onClickMenuButton,
    className: ACTION_MENU_CLASS_NAMES.BUTTON,
    "data-testid": "action-menu-button",
    "aria-controls": menuId,
    "aria-expanded": isMenuOpen,
    "aria-haspopup": true
  };
  const composedActionMenuStyles = composeActionMenuStyles(customCss);
  React78.useEffect(() => {
    if (selectedItemId !== void 0) {
      onSelectItem(selectedItemId);
      setSelectedItemId(void 0);
    }
  }, [selectedItemId, onSelectItem, setSelectedItemId]);
  return /* @__PURE__ */ React78.createElement(
    Box35,
    {
      css: composedActionMenuStyles,
      className: [ACTION_MENU_CLASS_NAMES.ACTION_MENU, customClassName].join(
        " "
      ),
      "data-testid": "action-menu"
    },
    React78.cloneElement(menuButton, menuButtonProps),
    /* @__PURE__ */ React78.createElement(
      Box35,
      {
        className: ACTION_MENU_CLASS_NAMES.POPUP,
        "data-testid": "action-menu-popup"
      },
      menuLabel && /* @__PURE__ */ React78.createElement(
        UtilityText2,
        {
          as: "div",
          className: ACTION_MENU_CLASS_NAMES.LABEL,
          "data-testid": "action-menu-label",
          emphasis: "emphasized",
          id: menuLabelId
        },
        menuLabel
      ),
      /* @__PURE__ */ React78.createElement(
        Box35,
        {
          "aria-describedby": menuLabelId,
          "aria-labelledby": menuButtonId,
          as: "ul",
          className: ACTION_MENU_CLASS_NAMES.LIST,
          id: menuId,
          role: "menu"
        },
        menuItems.map((item) => /* @__PURE__ */ React78.createElement(
          UtilityText2,
          {
            as: "li",
            className: ACTION_MENU_CLASS_NAMES.LIST_ITEM,
            id: item.id,
            key: item.id,
            onClick: onClickMenuItem,
            role: "menuitem",
            tabIndex: -1,
            ref: setMenuItemRef
          },
          item.label
        ))
      )
    )
  );
};

// src/components/switch/switch-indicator.component.tsx
import * as React79 from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import {
  styled as styled6,
  Icon as Icon8,
  Spinner as Spinner2,
  StackLayout as StackLayout10
} from "@leagueplatform/genesis-core";
var SwitchRoot = styled6(RadixSwitch.Root, {
  $$borderThickness: "2px",
  $$thumbSize: "20px",
  all: "unset",
  width: "$three",
  minWidth: "$three",
  height: "calc($$thumbSize + $$borderThickness*2)",
  backgroundColor: "$interactiveActionSubdued",
  borderRadius: "$pill",
  position: "relative",
  ".GDS-icon": {
    transition: "opacity $transitions$defaultTime"
  },
  "&:focus": {
    boxShadow: "0 0 0 $$borderThickness $interactiveActionPrimary"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$interactiveActionPrimary",
    ".GDS-icon": {
      opacity: "1"
    }
  },
  '&[data-state="unchecked"]': {
    ".GDS-icon": {
      opacity: "0"
    }
  },
  "&[disabled]": {
    opacity: 0.5
  }
});
var SwitchThumb = styled6(RadixSwitch.Thumb, {
  display: "block",
  width: "$$thumbSize",
  height: "$$thumbSize",
  backgroundColor: "$interactiveBackgroundDefault",
  borderRadius: "$circle",
  transition: "transform $transitions$defaultTime",
  transform: "translateX($$borderThickness)",
  willChange: "transform",
  '&[data-state="checked"]': {
    transform: "translateX(calc($space$oneAndHalf + $$borderThickness))"
  }
});
var Wrapper = styled6("span", {
  variants: {
    loading: {
      true: {
        ".cc-switch-root": {
          backgroundColor: "$none"
        },
        ".cc-switch-thumb, .cc-switch-icon": {
          display: "none"
        }
      }
    }
  }
});
var SwitchIndicator = (_a) => {
  var _b = _a, {
    css: css21,
    className = "",
    id,
    checked,
    hideIcon,
    ariaLabelledBy,
    ariaLabel,
    ariaDisabled,
    loading,
    onChange
  } = _b, props = __objRest(_b, [
    "css",
    "className",
    "id",
    "checked",
    "hideIcon",
    "ariaLabelledBy",
    "ariaLabel",
    "ariaDisabled",
    "loading",
    "onChange"
  ]);
  return /* @__PURE__ */ React79.createElement(
    Wrapper,
    {
      loading,
      className: ["cc-switch-root-wrapper", className].join(" ")
    },
    /* @__PURE__ */ React79.createElement(
      SwitchRoot,
      __spreadValues({
        id,
        onCheckedChange: onChange,
        checked,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        "aria-disabled": ariaDisabled,
        className: "cc-switch-root"
      }, props),
      !hideIcon && /* @__PURE__ */ React79.createElement(
        Icon8,
        {
          icon: "interfaceCheckmark",
          className: "cc-switch-icon",
          "data-testid": "switch-icon",
          tint: "$interactiveIconDefault",
          css: {
            position: "absolute",
            top: "$none",
            left: "$$borderThickness"
          }
        }
      ),
      loading && /* @__PURE__ */ React79.createElement(
        StackLayout10,
        {
          css: { width: "$three", flex: "unset" },
          horizontalAlignment: "spaceAround",
          orientation: "horizontal"
        },
        /* @__PURE__ */ React79.createElement(Spinner2, { loading, size: "20px", "data-testid": "switch-spinner" })
      ),
      /* @__PURE__ */ React79.createElement(SwitchThumb, { className: "cc-switch-thumb" })
    )
  );
};

// src/components/switch/switch.component.tsx
import React80, { isValidElement } from "react";
import { styled as styled7 } from "@leagueplatform/genesis-core";
var LabelText2 = styled7("span", {
  typography: "$bodyOne",
  variants: {
    disabled: {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    },
    "aria-disabled": {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    }
  }
});
var SwitchLabel = styled7("label", {
  gap: "$half",
  borderRadius: "$medium",
  padding: "$half",
  variants: {
    layout: {
      row: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(button:focus)": {
          boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
          // Visible in Windows high-contrast themes
          outline: "$borderWidths$innerFocus  solid transparent",
          button: {
            '&[class*="cc-"]': {
              outline: "none"
            }
          }
        }
      },
      inline: {
        display: "inline-flex",
        "&:focus-within": {
          "&:focus-within:has(button:focus)": {
            boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
            // Visible in Windows high-contrast themes
            outline: "$borderWidths$innerFocus  solid transparent",
            button: {
              '&[class*="cc-"]': {
                outline: "none"
              }
            }
          }
        }
      }
    },
    disabled: {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var Wrapper2 = styled7("div");
var Switch = (_a) => {
  var _b = _a, {
    label,
    layout = "inline",
    css: css21,
    id,
    checked,
    disabled,
    ariaDisabled,
    onClick,
    onChange,
    onBlur,
    onFocus
  } = _b, props = __objRest(_b, [
    "label",
    "layout",
    "css",
    "id",
    "checked",
    "disabled",
    "ariaDisabled",
    "onClick",
    "onChange",
    "onBlur",
    "onFocus"
  ]);
  const labelId = `${id}-label`;
  return layout === "row" ? /* @__PURE__ */ React80.createElement(Wrapper2, { className: "cc-switch-row", css: __spreadProps(__spreadValues({}, css21), { width: "100%" }) }, /* @__PURE__ */ React80.createElement(
    SwitchLabel,
    {
      className: "cc-switch-label",
      id: labelId,
      htmlFor: id,
      layout,
      disabled,
      "aria-disabled": ariaDisabled
    },
    /* @__PURE__ */ React80.createElement(
      LabelText2,
      {
        className: "cc-switch-label-text",
        disabled,
        "aria-disabled": ariaDisabled
      },
      label
    ),
    /* @__PURE__ */ React80.createElement(
      SwitchIndicator,
      __spreadValues({
        id,
        checked,
        disabled,
        "aria-disabled": ariaDisabled,
        ariaLabelledBy: labelId,
        onClick,
        onChange,
        onBlur,
        onFocus,
        css: {
          marginLeft: "$half"
        }
      }, props)
    )
  )) : /* @__PURE__ */ React80.createElement(Wrapper2, { className: "cc-switch-inline", css: __spreadValues({}, css21) }, /* @__PURE__ */ React80.createElement(
    SwitchLabel,
    {
      id: labelId,
      className: "cc-switch-label",
      htmlFor: id,
      layout,
      disabled,
      "aria-disabled": ariaDisabled
    },
    /* @__PURE__ */ React80.createElement(
      SwitchIndicator,
      __spreadValues({
        id,
        checked,
        disabled,
        "aria-disabled": ariaDisabled,
        ariaLabelledBy: labelId,
        onClick,
        onChange,
        onBlur,
        onFocus
      }, props)
    ),
    isValidElement(label) ? label : /* @__PURE__ */ React80.createElement(
      LabelText2,
      {
        className: "cc-switch-label-text",
        disabled,
        "aria-disabled": ariaDisabled
      },
      label
    )
  ));
};

// src/index.ts
initModule();
export {
  Accordion,
  ActionMenu,
  AppBarComponent,
  AppBarHeader,
  AppBarItem,
  AppBarLink,
  AppBarNav,
  AppBarNavLink,
  AppBarNavList,
  AppleAppIcon,
  AssessmentExitModal,
  Avatar,
  BackButtonArrow,
  Badge,
  CHECKBOX,
  CONTENT_MAX_WIDTH,
  CTAMediaObject,
  CalendarView,
  CalloutBanner,
  CardBanner,
  Carousel,
  ConditionalLink,
  ConditionalLinkCard,
  DATE,
  DimensionOfHealthModal,
  DocumentCard,
  ErrorState,
  ExternalRedirect,
  EyebrowEarnPoints,
  FadeAndGrow,
  FadeIn,
  FeedbackCard,
  FieldGrid,
  FieldSection,
  FieldWrapper,
  FullPageError,
  GenesisRouterLink,
  GoogleAppIcon,
  Grow,
  HIDDEN,
  HighlightBanner,
  HighlightCard,
  IconText,
  InputField,
  InternalOrExternalLink,
  InternalOrExternalLinkButton,
  LanguageSelector,
  LoadingIndicator,
  MULTISELECT,
  MainPageContainer,
  OpensInANewTabMessage,
  PageHeaderBackground,
  PageNotFound,
  PillTab,
  PillTabList,
  PillTabs,
  ProfileModal,
  ProgressBar,
  ProgressRing,
  RADIO,
  SELECT,
  SIDEBAR_MIN_WIDTH,
  STATUS_OPTIONS,
  Sidebar,
  SidebarCard,
  SkeletonBox,
  SkeletonCards,
  SlideInHorizontal,
  StackLayout2 as StackLayout,
  StatusBadge,
  Switch,
  SwitchIndicator,
  SwoopHeader,
  TEXT,
  UserDropdownComponent,
  VeryQuietButton,
  WithHiddenDescription,
  addSidebarSpacing
};
//# sourceMappingURL=index.js.map